(function() {
	function getAlgoliaFactory() {
		if (
			window["algoliasearch/lite"] &&
			typeof window["algoliasearch/lite"].liteClient === "function"
		) {
			return window["algoliasearch/lite"].liteClient;
		}
		if (typeof window.algoliasearch === "function") {
			return window.algoliasearch;
		}
		if (window.algoliasearch && typeof window.algoliasearch.algoliasearch === "function") {
			return window.algoliasearch.algoliasearch;
		}
		return null;
	}

	function getAutocompleteLib() {
		if (window.autocomplete && typeof window.autocomplete === "function") {
			return { autocomplete: window.autocomplete };
		}
		if (
			window["@" + "algolia/autocomplete-js"] &&
			typeof window["@" + "algolia/autocomplete-js"].autocomplete === "function"
		) {
			return window["@" + "algolia/autocomplete-js"];
		}
		return null;
	}

	/** Delay async work until typing pauses (Algolia autocomplete debounce pattern). */
	function debouncePromise(fn, waitMs) {
		var timerId = null;
		return function debounced() {
			var args = arguments;
			var context = this;
			if (timerId) {
				clearTimeout(timerId);
			}
			return new Promise(function(resolve, reject) {
				timerId = setTimeout(function() {
					Promise.resolve(fn.apply(context, args)).then(resolve, reject);
				}, waitMs);
			});
		};
	}

	function algoliaText(key, fallback) {
		var strings = window.algoliaStrings || {};
		return decodeHtmlEntities(strings[key] || fallback);
	}

	function algoliaTextForQuery(key, fallback, query) {
		var translatedText = algoliaText(key, fallback).replace(/&quot;|&#34;/gi, '"');
		var safeQuery = String(query || "").replace(/&quot;|&#34;/gi, '"');
		return translatedText.replace("{{ query }}", safeQuery);
	}

	function normalizeBaseUrl(value) {
		if (!value) {
			return null;
		}
		try {
			return new URL(value).origin;
		} catch (e) {
			return null;
		}
	}

	function normalizeHost(value) {
		return String(value || "").trim().toLowerCase().replace(/\.$/, "");
	}

	function hostFromUrl(urlValue) {
		if (!urlValue) return null;
		try {
			return normalizeHost(new URL(urlValue).hostname);
		} catch (e) {
			return null;
		}
	}

	function buildAllowedHosts(config) {
		var hosts = {};

		function addHost(host) {
			var normalized = normalizeHost(host);
			if (normalized) {
				hosts[normalized] = true;
			}
		}

		var inferred = [
			window.location.origin,
			config.helpCenterUrl,
			config.searchPath,
			config.shopifyBaseUrl,
			config.servicesBaseUrl,
			config.wordpressBaseUrl,
			config.shopBaseUrl,
			config.storeBaseUrl,
			config.zendeskBaseUrl,
			config.wordpressBaseUrl,
			config.wpBaseUrl,
			config.siteBaseUrl
		];

		inferred.forEach(function(value) {
			addHost(hostFromUrl(value));
		});

		// Optional explicit override list in config: "a.com,b.com"
		String(config.allowedHosts || "")
			.split(",")
			.forEach(function(part) {
				addHost(part);
			});

		return hosts;
	}

	function isAllowedHost(hostname, allowedHostsMap) {
		var host = normalizeHost(hostname);
		if (!host) return false;
		var keys = Object.keys(allowedHostsMap || {});
		if (!keys.length) return true;
		return keys.some(function(allowed) {
			return host === allowed || host.endsWith("." + allowed);
		});
	}

	function isShopifyStorefront() {
		try {
			var host = String(window.location.hostname || "").toLowerCase();
			if (host.endsWith(".myshopify.com")) {
				return true;
			}
			if (typeof window.Shopify !== "undefined" && window.Shopify && window.Shopify.shop) {
				return true;
			}
		} catch (e) {}
		return false;
	}

	function isFyrcoWordPressSite() {
		try {
			return document.documentElement.classList.contains("fyrco-wordpress");
		} catch (e) {
			return false;
		}
	}

	function inferStoreBaseUrl(config) {
		if (isShopifyStorefront()) {
			return normalizeBaseUrl(window.location.origin);
		}

		var explicit =
			normalizeBaseUrl(config.shopifyBaseUrl) ||
			normalizeBaseUrl(config.shopBaseUrl) ||
			normalizeBaseUrl(config.storeBaseUrl);
		if (explicit) {
			return explicit;
		}

		var helpCenterBase =
			normalizeBaseUrl(config.helpCenterUrl) ||
			(config.searchPath ? normalizeBaseUrl(config.searchPath) : null);
		if (!helpCenterBase) {
			return null;
		}

		try {
			var hc = new URL(helpCenterBase);
			if (/^support\./i.test(hc.hostname)) {
				hc.hostname = hc.hostname.replace(/^support\./i, "");
			}
			return hc.origin;
		} catch (e) {
			return null;
		}
	}

	function getQueryParamName(config) {
		return String((config && config.queryParamName) || "query").trim() || "query";
	}

	function getSearchQueryFromUrl(config) {
		return new URLSearchParams(window.location.search).get(getQueryParamName(config)) || "";
	}

	function buildSearchResultsUrl(config, searchQuery) {
		var base = String(config.searchPath || (window.location.origin + "/search"));
		var paramName = getQueryParamName(config);
		try {
			var url = new URL(base, window.location.origin);
			url.searchParams.set(paramName, searchQuery);
			return url.href;
		} catch (e) {
			return base + (base.indexOf("?") === -1 ? "?" : "&") + encodeURIComponent(paramName) + "=" + encodeURIComponent(searchQuery);
		}
	}

	function platformBaseUrl(platform, config) {
		if (platform === "shopify") {
			return inferStoreBaseUrl(config);
		}
		if (platform === "zendesk") {
			return (
				normalizeBaseUrl(config.zendeskBaseUrl) ||
				normalizeBaseUrl(config.helpCenterUrl) ||
				(config.searchPath ? normalizeBaseUrl(config.searchPath) : null) ||
				normalizeBaseUrl(window.location.origin)
			);
		}
		if (platform === "wordpress") {
			return (
				normalizeBaseUrl(config.wordpressBaseUrl) ||
				normalizeBaseUrl(config.wpBaseUrl) ||
				normalizeBaseUrl(config.siteBaseUrl)
			);
		}
		return null;
	}

	function joinBaseAndPath(base, path) {
		if (!base || !path) {
			return null;
		}
		try {
			return new URL(path, base).href;
		} catch (e) {
			return null;
		}
	}

	function firstNonEmptyString(values) {
		for (var i = 0; i < values.length; i += 1) {
			var value = String(values[i] || "").trim();
			if (value) {
				return value;
			}
		}
		return "";
	}

	function shopifyHandleFromItem(item, rawUrl) {
		var directHandle = String((item && item.handle) || "").trim();
		if (directHandle) {
			return directHandle;
		}
		if (!rawUrl) {
			return "";
		}
		try {
			var parsed = new URL(rawUrl, window.location.origin);
			var matchProducts = parsed.pathname.match(/\/products\/([^/?#]+)/i);
			if (matchProducts && matchProducts[1]) {
				return decodeURIComponent(matchProducts[1]);
			}
			var matchPages = parsed.pathname.match(/\/pages\/([^/?#]+)/i);
			if (matchPages && matchPages[1]) {
				return decodeURIComponent(matchPages[1]);
			}
			var matchCollections = parsed.pathname.match(/\/collections\/([^/?#]+)/i);
			return matchCollections && matchCollections[1]
				? decodeURIComponent(matchCollections[1])
				: "";
		} catch (e) {
			return "";
		}
	}

	function resolveShopifyRawUrl(item, config) {
		var candidate = firstNonEmptyString([
			item && item.shopify_url,
			item && item.shopifyUrl,
			item && item.online_store_url,
			item && item.onlineStoreUrl,
			item && item.canonical_url,
			item && item.canonicalUrl,
			item && item.url
		]);

		var overrides = config && config.shopifyUrlOverrides;
		if (!overrides || typeof overrides !== "object") {
			return candidate;
		}

		var handle = shopifyHandleFromItem(item, candidate);
		if (!handle) {
			return candidate;
		}

		var overrideUrl = String(overrides[handle] || "").trim();
		return overrideUrl || candidate;
	}

	function resolveItemUrl(item, config) {
		var platform = String((item && item.platform) || "").toLowerCase();
		var rawUrl =
			platform === "shopify"
				? resolveShopifyRawUrl(item, config)
				: item && item.url
					? String(item.url).trim()
					: "";
		var base = platformBaseUrl(platform, config);
		if (!rawUrl && platform === "shopify") {
			var handleOnly = shopifyHandleFromItem(item, "");
			var itemType = String((item && item.type) || "").toLowerCase();
			if (handleOnly && base) {
				if (itemType === "page") {
					rawUrl = "/pages/" + encodeURIComponent(handleOnly);
				} else if (itemType === "collection") {
					rawUrl = "/collections/" + encodeURIComponent(handleOnly);
				} else {
					rawUrl = "/products/" + encodeURIComponent(handleOnly);
				}
			}
		}
		if (!rawUrl) {
			return null;
		}

		if (platform === "zendesk") {
			var fromRedirectMeta = resolveZendeskItemUrl(item, config);
			if (fromRedirectMeta) {
				return fromRedirectMeta;
			}
			return resolveZendeskOutboundUrl(rawUrl, config);
		}

		try {
			var parsed = new URL(rawUrl, window.location.origin);
			if (!/^https?:$/i.test(parsed.protocol)) {
				return null;
			}

			if (isZendeskHelpCenterPath(parsed.pathname)) {
				var hcBase = platformBaseUrl("zendesk", config) || window.location.origin;
				return (
					joinBaseAndPath(hcBase, parsed.pathname + parsed.search + parsed.hash) ||
					parsed.href
				);
			}

			// Force platform domain when path clearly belongs there.
			// Shopify: only rewrite relative paths or *.myshopify.com — keep absolute
			// locale-market URLs (e.g. fr-be → protectionincendieshop.be).
			if (base) {
				var baseHost = new URL(base).hostname;
				var isShopifyStorePath = /^\/(products|pages|collections)\//i.test(parsed.pathname);
				var isMyshopifyHost = /\.myshopify\.com$/i.test(parsed.hostname);
				var hasAbsoluteInput = /^[a-z][a-z\d+\-.]*:/i.test(rawUrl);
				var hasRelativeInput = !hasAbsoluteInput;
				var shouldForceShop =
					platform === "shopify" && isShopifyStorePath && (hasRelativeInput || isMyshopifyHost);
				var shouldForceZendesk = platform === "zendesk" && /^\/hc\//i.test(parsed.pathname);
				if (
					platform === "shopify" &&
					hasAbsoluteInput &&
					isShopifyStorePath &&
					!isMyshopifyHost
				) {
					return parsed.href;
				}
				if (shouldForceShop || shouldForceZendesk || hasRelativeInput) {
					return joinBaseAndPath(base, parsed.pathname + parsed.search + parsed.hash) || parsed.href;
				}
				if (parsed.hostname !== baseHost && (shouldForceShop || shouldForceZendesk)) {
					return joinBaseAndPath(base, parsed.pathname + parsed.search + parsed.hash) || parsed.href;
				}
			}

			// WordPress entries can intentionally live on another domain (e.g. fyrco.be).
			// Keep the resolved absolute URL instead of blocking on BBH host allowlist.
			if (platform === "wordpress") {
				return parsed.href;
			}

			if (!isAllowedHost(parsed.hostname, buildAllowedHosts(config || {}))) {
				return null;
			}
			return rewriteHelpCenterOutboundUrl(parsed.href, config);
		} catch (e) {
			var fallback = base ? joinBaseAndPath(base, rawUrl) : null;
			if (!fallback) return null;
			try {
				var fallbackHost = new URL(fallback).hostname;
				if (!isAllowedHost(fallbackHost, buildAllowedHosts(config || {}))) {
					return null;
				}
			} catch (err) {
				return null;
			}
			return fallback;
		}
	}

	function navigateToItem(item, config) {
		var itemUrl = resolveItemUrl(item, config);
		if (!itemUrl) {
			var raw = item && item.url ? String(item.url).trim() : "";
			var platform = String((item && item.platform) || "").toLowerCase();
			if (raw) {
				try {
					var parsed = new URL(raw, window.location.origin);
					if (!/^https?:$/i.test(parsed.protocol)) {
						itemUrl = null;
					} else if (platform === "zendesk" || isZendeskHelpCenterPath(parsed.pathname)) {
						itemUrl = resolveZendeskOutboundUrl(raw, config);
					} else {
						var hasAbsoluteInput = /^[a-z][a-z\d+\-.]*:/i.test(raw);
						if (hasAbsoluteInput) {
							itemUrl = parsed.href;
						} else {
							itemUrl =
								joinBaseAndPath(
									platformBaseUrl(platform, config) || window.location.origin,
									parsed.pathname + parsed.search + parsed.hash
								) || parsed.href;
						}
					}
				} catch (e) {
					itemUrl = null;
				}
			}
		}
		if (!itemUrl) {
			return false;
		}

		trackSearchClick(item, config, "Hit Clicked");

		// Andere host (shop, fyrco.be, …) → nieuw venster; zelfde host → zelfde tab.
		if (shouldOpenItemInNewWindow(item, itemUrl, config)) {
			window.open(itemUrl, "_blank", "noopener,noreferrer");
			return true;
		}

		window.location.assign(itemUrl);
		return true;
	}

	function normalizeCompareHost(hostname) {
		return String(hostname || "")
			.replace(/^www\./i, "")
			.toLowerCase();
	}

	function isExternalNavigationUrl(itemUrl) {
		if (!itemUrl || itemUrl === "#") {
			return false;
		}
		try {
			var targetHost = normalizeCompareHost(new URL(itemUrl, window.location.origin).hostname);
			var currentHost = normalizeCompareHost(window.location.hostname);
			return !!(targetHost && currentHost && targetHost !== currentHost);
		} catch (e) {
			return false;
		}
	}

	function shouldOpenItemInNewWindow(item, itemUrl, config) {
		return isExternalNavigationUrl(itemUrl);
	}

	function insightsAttrsForItem(item) {
		if (!item || item.objectID == null || item.objectID === "") {
			return {};
		}
		var attrs = {
			"data-fyrco-object-id": String(item.objectID)
		};
		if (item.__queryID) {
			attrs["data-fyrco-query-id"] = String(item.__queryID);
		}
		if (item.__position) {
			attrs["data-fyrco-position"] = String(item.__position);
		}
		if (item.__indexName) {
			attrs["data-fyrco-index"] = String(item.__indexName);
		}
		return attrs;
	}

	function withExternalAnchor(html, href, className, children, item) {
		var url = href || "#";
		var external = isExternalNavigationUrl(url);
		var insightsAttrs = insightsAttrsForItem(item);
		if (className) {
			if (external) {
				return html`<a href="${url}" class="${className}" target="_blank" rel="noopener noreferrer" ...${insightsAttrs}>${children}</a>`;
			}
			return html`<a href="${url}" class="${className}" ...${insightsAttrs}>${children}</a>`;
		}
		if (external) {
			return html`<a href="${url}" target="_blank" rel="noopener noreferrer" ...${insightsAttrs}>${children}</a>`;
		}
		return html`<a href="${url}" ...${insightsAttrs}>${children}</a>`;
	}

	function insightsEnabled(config) {
		return !(config && (config.enableInsights === false || config.enableInsights === "false"));
	}

	function resolveInsightsObjectClient() {
		var bundle = window.AlgoliaAnalytics;
		if (!bundle) {
			return null;
		}
		if (bundle.default && typeof bundle.default.init === "function") {
			return bundle.default;
		}
		if (typeof bundle.init === "function") {
			return bundle;
		}
		if (typeof bundle.createInsightsClient === "function") {
			try {
				return bundle.createInsightsClient();
			} catch (e) {
				return null;
			}
		}
		return null;
	}

	function ensureInsightsAaGlobal() {
		if (typeof window.aa === "function") {
			return window.aa;
		}
		var client = resolveInsightsObjectClient();
		if (!client) {
			return null;
		}
		window.aa = function fyrcoInsightsAa(command, payload) {
			if (!command) {
				return;
			}
			if (typeof client[command] === "function") {
				return client[command](payload);
			}
		};
		return window.aa;
	}

	function ensureInsightsInitialized(config) {
		if (!insightsEnabled(config)) {
			return false;
		}
		var aa = ensureInsightsAaGlobal();
		if (typeof aa !== "function") {
			return false;
		}
		if (window.__fyrcoInsightsInitialized) {
			return true;
		}
		try {
			aa("init", {
				appId: config.appId,
				apiKey: config.searchApiKey,
				useCookie: true
			});
			window.__fyrcoInsightsInitialized = true;
			return true;
		} catch (error) {
			console.warn("Algolia Insights init failed:", error && error.message);
			return false;
		}
	}

	function trackSearchClick(item, config, eventName) {
		if (!item || item.objectID == null || item.objectID === "") {
			return;
		}
		if (!ensureInsightsInitialized(config)) {
			return;
		}
		var aa = ensureInsightsAaGlobal();
		if (typeof aa !== "function") {
			return;
		}
		var indexName = String(item.__indexName || (config && config.indexName) || "").trim();
		if (!indexName) {
			return;
		}
		var objectID = String(item.objectID);
		var queryID = item.__queryID || item.queryID || "";
		var dedupeKey = objectID + "|" + String(queryID);
		var now = Date.now();
		if (
			window.__fyrcoInsightsLastClickKey === dedupeKey &&
			now - (window.__fyrcoInsightsLastClickAt || 0) < 800
		) {
			return;
		}
		window.__fyrcoInsightsLastClickKey = dedupeKey;
		window.__fyrcoInsightsLastClickAt = now;
		var payload = {
			eventName: eventName || "Hit Clicked",
			index: indexName,
			objectIDs: [objectID]
		};
		var position = Number(item.__position || item.position || 0);
		try {
			if (queryID && position > 0) {
				aa(
					"clickedObjectIDsAfterSearch",
					Object.assign({}, payload, {
						queryID: String(queryID),
						positions: [position]
					})
				);
			} else {
				aa("clickedObjectIDs", payload);
			}
		} catch (error) {
			console.warn("Algolia Insights click failed:", error && error.message);
		}
	}

	function bindInsightsAnchorClicks(config) {
		if (window.__fyrcoInsightsAnchorBound || !insightsEnabled(config)) {
			return;
		}
		window.__fyrcoInsightsAnchorBound = true;
		document.addEventListener(
			"click",
			function(event) {
				var target = event && event.target;
				var anchor =
					target && target.closest
						? target.closest("a[data-fyrco-object-id]")
						: null;
				if (!anchor) {
					return;
				}
				trackSearchClick(
					{
						objectID: anchor.getAttribute("data-fyrco-object-id"),
						__queryID: anchor.getAttribute("data-fyrco-query-id"),
						__position: Number(anchor.getAttribute("data-fyrco-position") || 0),
						__indexName: anchor.getAttribute("data-fyrco-index")
					},
					config,
					"Hit Clicked"
				);
			},
			true
		);
	}

	function sourceDomainLabel(item, config) {
		var resolved = resolveItemUrl(item, config);
		if (!resolved) {
			return String((item && item.platform) || algoliaText("result", "resultaat"));
		}
		try {
			var host = new URL(resolved).hostname || "";
			return host.replace(/^www\./i, "") || String((item && item.platform) || algoliaText("result", "resultaat"));
		} catch (e) {
			return String((item && item.platform) || algoliaText("result", "resultaat"));
		}
	}

	function truncateText(value, maxChars) {
		var text = String(value || "").replace(/\s+/g, " ").trim();
		if (!text) return "";
		if (!maxChars || text.length <= maxChars) return text;
		return text.slice(0, Math.max(1, maxChars - 1)).trimEnd() + "...";
	}

	function truncateAtWord(value, maxChars) {
		var text = String(value || "").replace(/\s+/g, " ").trim();
		if (!text) return "";
		if (!maxChars || text.length <= maxChars) return text;
		var cut = text.slice(0, maxChars);
		var lastSpace = cut.lastIndexOf(" ");
		if (lastSpace > Math.floor(maxChars * 0.55)) {
			cut = cut.slice(0, lastSpace);
		}
		return cut.trimEnd() + "...";
	}

	function escapeHtml(value) {
		return String(value || "")
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;");
	}

	function renderAutocompleteEmptyFallback(html, queryText, config, options) {
		var opts = options || {};
		var query = String(queryText || "").trim();
		var label = opts.label || algoliaText("noResultsTitle", "Geen resultaten gevonden");
		var message =
			opts.message ||
			(query
				? algoliaTextForQuery("noResultsForQuery", 'We vonden geen resultaten voor "{{ query }}".', query)
				: algoliaText("noResultsForSearch", "We vonden geen resultaten voor je zoekopdracht."));
		return html`
			<div class="aa-EmptyFallback" role="status">
				<p class="aa-EmptyFallbackTitle">${label}</p>
				<p class="aa-EmptyFallbackText">${message}</p>
				<p class="aa-EmptyFallbackText">${algoliaText("tryAnotherSearch", "Probeer een andere zoekterm.")}</p>
			</div>
		`;
	}

	function buildResultsPageEmptyHtml(query, config) {
		var safeQuery = escapeHtml(String(query || "").trim());
		var helpUrl = escapeHtml(
			String(config.helpCenterUrl || config.zendeskBaseUrl || window.location.origin || "/")
		);
		return (
			'<div class="fyrco-algolia-empty" role="status">' +
			'<h2 class="fyrco-algolia-empty-title">' + algoliaText("noResultsTitle", "Geen resultaten gevonden") + "</h2>" +
			(safeQuery
				? '<p class="fyrco-algolia-empty-text">' +
					algoliaTextForQuery("noResultsForQuery", 'We vonden geen resultaten voor "{{ query }}".', safeQuery) +
					"</p>"
				: "") +
			'<p class="fyrco-algolia-empty-text">' +
				algoliaText("tryAnotherSearchOrRemoveFilters", "Probeer een andere zoekterm of verwijder actieve filters.") +
			"</p>" +
			'<div class="fyrco-algolia-empty-actions">' +
			'<a class="fyrco-algolia-empty-link" href="' +
			helpUrl +
			'">' + algoliaText("backToHelpCenter", "Terug naar help center") + "</a>" +
			"</div>" +
			"</div>"
		);
	}

	function getAutocompleteCollectionsKey(state) {
		var collections = (state && state.collections) || [];
		return collections
			.map(function(collection) {
				var source = collection && collection.source;
				var sourceId = (source && (source.sourceId || source.id)) || "";
				var items = (collection && collection.items) || [];
				return sourceId + ":" + items.length;
			})
			.join("|");
	}

	function shouldSyncAutocompleteLayout(prev, next) {
		if (!next || !next.isOpen) {
			return { sync: false, delayed: false };
		}
		if (!prev || !prev.isOpen) {
			return { sync: true, delayed: true };
		}
		if (String(prev.query || "").trim() !== String(next.query || "").trim()) {
			return { sync: true, delayed: true };
		}
		if (getAutocompleteCollectionsKey(prev) !== getAutocompleteCollectionsKey(next)) {
			return { sync: true, delayed: true };
		}
		return { sync: false, delayed: false };
	}

	function captureAutocompleteScrollPositions(root) {
		var positions = [];
		if (!root) {
			return positions;
		}
		Array.prototype.slice
			.call(
				root.querySelectorAll(
					'.aa-Source:not([data-autocomplete-source-id="ubersearch_left_menu"]):not([data-autocomplete-source-id="ubersearch_tabs"])'
				)
			)
			.forEach(function(el) {
				if (el.scrollTop > 0) {
					positions.push({ el: el, top: el.scrollTop });
				}
			});
		if (root.scrollTop > 0) {
			positions.push({ el: root, top: root.scrollTop });
		}
		var layoutNode = root.querySelector(".aa-PanelLayout");
		if (layoutNode && layoutNode.scrollTop > 0) {
			positions.push({ el: layoutNode, top: layoutNode.scrollTop });
		}
		return positions;
	}

	function restoreAutocompleteScrollPositions(positions) {
		(positions || []).forEach(function(entry) {
			if (entry && entry.el && entry.el.isConnected) {
				entry.el.scrollTop = entry.top;
			}
		});
	}

	function preserveAutocompleteScrollOnNextFrame(root) {
		var savedScroll = captureAutocompleteScrollPositions(root);
		if (!savedScroll.length) {
			return;
		}
		var run = function() {
			restoreAutocompleteScrollPositions(savedScroll);
		};
		if (typeof window.requestAnimationFrame === "function") {
			window.requestAnimationFrame(function() {
				window.requestAnimationFrame(run);
			});
			return;
		}
		window.setTimeout(run, 16);
	}

	function isAutocompleteStackedLayout() {
		return window.matchMedia("(max-width: 1024px)").matches;
	}

	var leftMenuAccordionOpenByTitle = {};

	function syncLeftMenuAccordionState(root) {
		if (!root || !root.querySelectorAll) {
			return;
		}
		var stacked = isAutocompleteStackedLayout();
		Array.prototype.slice.call(root.querySelectorAll(".aa-LeftMenuAccordion")).forEach(function(details) {
			if (!details) {
				return;
			}
			var key = String(details.getAttribute("data-fyrco-accordion-key") || "").trim();
			// Desktop: always open so groups stay visible (UA hides closed details).
			var shouldOpen = !stacked || !!(key && leftMenuAccordionOpenByTitle[key]);
			if (!!details.open !== shouldOpen) {
				details.open = shouldOpen;
			}
			if (details.getAttribute("data-fyrco-accordion-bound") === "1") {
				return;
			}
			details.setAttribute("data-fyrco-accordion-bound", "1");
			details.addEventListener("toggle", function() {
				if (!isAutocompleteStackedLayout()) {
					details.open = true;
					return;
				}
				if (key) {
					leftMenuAccordionOpenByTitle[key] = !!details.open;
				}
				markAutocompletePanelInteraction(800);
			});
		});
	}

	function getAutocompleteViewportHeight() {
		// Use the layout viewport on purpose: iOS soft keyboard must NOT shrink the
		// panel. (visualViewport.height collapses with the keyboard and made the
		// panel look "broken"; closing the keyboard restored full size.)
		return window.innerHeight || 800;
	}

	function isMobileAutocompleteViewport() {
		return window.matchMedia("(max-width: 1024px)").matches;
	}

	function markAutocompletePanelInteraction(ms) {
		var holdMs = typeof ms === "number" ? ms : 1200;
		window._fyrcoKeepAutocompleteOpenUntil = Date.now() + holdMs;
	}

	function shouldSuppressAutocompleteDismiss() {
		return Date.now() < (window._fyrcoKeepAutocompleteOpenUntil || 0);
	}

	function getAutocompleteViewportAvailable(panelRect) {
		var panelTop = Math.max(0, Math.floor((panelRect && panelRect.top) || 0));
		var viewportH = getAutocompleteViewportHeight();
		var bottomInset = 24;
		var minHeight = isMobileAutocompleteViewport() ? 160 : 280;
		return Math.max(minHeight, Math.floor(viewportH) - panelTop - bottomInset);
	}

	function measureAutocompleteContentHeight(node) {
		var layoutNode = node && node.querySelector(".aa-PanelLayout");
		if (!layoutNode) {
			return 0;
		}
		var tabsNode = node.querySelector('.aa-Source[data-autocomplete-source-id="ubersearch_tabs"]');
		var tabsHeight = tabsNode ? Math.ceil(tabsNode.offsetHeight || 0) : 0;
		var resultsSources = node.querySelectorAll(
			'.aa-Source:not([data-autocomplete-source-id="ubersearch_left_menu"]):not([data-autocomplete-source-id="ubersearch_tabs"])'
		);
		var resultsHeight = 0;
		Array.prototype.forEach.call(resultsSources, function(source) {
			resultsHeight += Math.ceil(source.scrollHeight || source.offsetHeight || 0);
		});
		var sidebarNode = node.querySelector('.aa-Source[data-autocomplete-source-id="ubersearch_left_menu"]');
		var sidebarHeight = sidebarNode
			? Math.ceil(sidebarNode.scrollHeight || sidebarNode.offsetHeight || 0)
			: 0;
		var columnHeight = tabsHeight + resultsHeight;
		if (isAutocompleteStackedLayout()) {
			if (columnHeight || sidebarHeight) {
				return sidebarHeight + columnHeight;
			}
		} else if (columnHeight || sidebarHeight) {
			return Math.max(columnHeight, sidebarHeight);
		}
		return Math.ceil(layoutNode.scrollHeight || layoutNode.offsetHeight || 0);
	}

	function bindAutocompleteLayoutObserver(node) {
		if (!node || node._fyrcoLayoutObserverBound) {
			return;
		}
		var layoutNode = node.querySelector(".aa-PanelLayout");
		if (!layoutNode || typeof window.ResizeObserver !== "function") {
			return;
		}
		node._fyrcoLayoutObserverBound = true;
		var resizeTimer = null;
		node._fyrcoLayoutObserver = new window.ResizeObserver(function() {
			if (resizeTimer) {
				window.clearTimeout(resizeTimer);
			}
			resizeTimer = window.setTimeout(function() {
				syncAutocompleteLayoutMetrics();
			}, 60);
		});
		node._fyrcoLayoutObserver.observe(layoutNode);
	}

	function observeAutocompletePanelImages(node) {
		if (!node) {
			return;
		}
		Array.prototype.slice.call(node.querySelectorAll("img")).forEach(function(img) {
			if (!img || img.complete || img._fyrcoLayoutObserved) {
				return;
			}
			img._fyrcoLayoutObserved = true;
			img.addEventListener(
				"load",
				function() {
					scheduleAutocompleteLayoutSync({ includeDelayed: true });
				},
				{ once: true }
			);
		});
	}

	function didOnlyActiveAutocompleteItemChange(prev, next) {
		if (!prev || !next || !next.isOpen || !prev.isOpen) {
			return false;
		}
		if (String(prev.query || "").trim() !== String(next.query || "").trim()) {
			return false;
		}
		if (getAutocompleteCollectionsKey(prev) !== getAutocompleteCollectionsKey(next)) {
			return false;
		}
		return prev.activeItemId !== next.activeItemId;
	}

	function scheduleAutocompleteLayoutSync(options) {
		var opts = options || {};
		var includeDelayed = opts.includeDelayed !== false;
		function run() {
			syncAutocompleteLayoutMetrics();
		}
		if (typeof window.requestAnimationFrame === "function") {
			window.requestAnimationFrame(function() {
				window.requestAnimationFrame(run);
			});
		} else {
			window.setTimeout(run, 50);
		}
		if (includeDelayed) {
			window.setTimeout(run, 120);
			window.setTimeout(run, 320);
			window.setTimeout(run, 720);
		}
	}


	function clearAutocompletePanelAlignment(node) {
		if (!node || node.getAttribute("data-fyrco-panel-aligned") !== "true") {
			return;
		}
		node.removeAttribute("data-fyrco-panel-aligned");
		node.style.removeProperty("position");
		node.style.removeProperty("left");
		node.style.removeProperty("right");
		node.style.removeProperty("top");
		node.style.removeProperty("transform");
		node.style.removeProperty("width");
	}

	function alignAutocompletePanelToInput(node) {
		if (!node || !node.getBoundingClientRect) {
			return;
		}
		var openMount = document.querySelector(
			'[data-fyrco-algolia-search][data-fyrco-ac-panel-open="true"], #fyrco-algolia-search[data-fyrco-ac-panel-open="true"]'
		);
		var form = openMount
			? openMount.querySelector(".aa-Form") || openMount.querySelector(".aa-Input")
			: null;
		if (!form) {
			clearAutocompletePanelAlignment(node);
			return;
		}
		var formRect = form.getBoundingClientRect();
		// clientWidth avoids iOS 100vw/scrollbar overflow that can clip the panel.
		var vw = document.documentElement.clientWidth || window.innerWidth || 0;
		if (!vw || formRect.width < 1) {
			return;
		}
		var gutter = 16;
		var maxWidth = Math.max(0, vw - gutter * 2);
		var panelWidth = Math.min(970, maxWidth);
		var leftVp;
		if (isMobileAutocompleteViewport() || panelWidth >= maxWidth - 1) {
			// Phone/tablet (and near-full-width): pin to gutters so nothing falls off.
			leftVp = gutter;
			panelWidth = maxWidth;
		} else if (panelWidth <= formRect.width + 8) {
			leftVp = formRect.left;
		} else {
			// Desktop Shopify: wider panel under a narrow header slot → center, then clamp.
			leftVp = formRect.left + (formRect.width - panelWidth) / 2;
		}
		leftVp = Math.max(gutter, Math.min(leftVp, vw - gutter - panelWidth));
		var viewportH = getAutocompleteViewportHeight();
		var topVp = formRect.bottom + 8;
		// Keep enough room for the panel above the fold; height sync scrolls inside.
		var maxTop = Math.max(gutter, viewportH - (isMobileAutocompleteViewport() ? 160 : 280));
		topVp = Math.min(Math.max(gutter, topVp), maxTop);
		node.style.setProperty("position", "fixed", "important");
		node.style.setProperty("left", Math.round(leftVp) + "px", "important");
		node.style.setProperty("right", "auto", "important");
		node.style.setProperty("top", Math.round(topVp) + "px", "important");
		node.style.setProperty("transform", "none", "important");
		node.style.setProperty("width", Math.round(panelWidth) + "px", "important");
		node.setAttribute("data-fyrco-panel-aligned", "true");
	}

	function syncAutocompleteLayoutMetrics() {
		if (window._fyrcoLayoutSyncInProgress) {
			return;
		}
		window._fyrcoLayoutSyncInProgress = true;
		try {
			Array.prototype.slice
				.call(document.querySelectorAll(".aa-Panel, .aa-DetachedContainer"))
				.forEach(function(node) {
				if (!node || !node.getBoundingClientRect) {
					return;
				}
				alignAutocompletePanelToInput(node);
				var savedScroll = captureAutocompleteScrollPositions(node);
				var hadInternalScroll = node.getAttribute("data-fyrco-panel-scroll") === "true";
				if (hadInternalScroll) {
					node.removeAttribute("data-fyrco-panel-scroll");
					node.style.removeProperty("--fyrco-panel-height");
					node.style.setProperty("--fyrco-source-max-height", "none");
				}
				var panelRect = node.getBoundingClientRect();
				if (!panelRect.width && !panelRect.height) {
					if (hadInternalScroll) {
						node.setAttribute("data-fyrco-panel-scroll", "true");
					}
					return;
				}
				var viewportAvailable = getAutocompleteViewportAvailable(panelRect);
				var panelMaxHeight = viewportAvailable;
				var naturalHeight = measureAutocompleteContentHeight(node);
				var needsInternalScroll = naturalHeight > panelMaxHeight;

				node.style.setProperty("--fyrco-panel-offset", Math.max(0, Math.floor(panelRect.top || 0) + 24) + "px");
				var tabsNode = node.querySelector('.aa-Source[data-autocomplete-source-id="ubersearch_tabs"]');
				var tabsHeight = tabsNode ? Math.ceil(tabsNode.offsetHeight || 0) : 0;
				node.style.setProperty("--fyrco-sidebar-offset", tabsHeight + "px");
				node.style.setProperty("--fyrco-panel-max-height", panelMaxHeight + "px");
				node.style.removeProperty("--fyrco-panel-min-height");
				if (node.getAttribute("data-fyrco-keyboard-open") === "true") {
					// Legacy cleanup if an older build pinned the panel fixed.
					node.removeAttribute("data-fyrco-keyboard-open");
					node.style.removeProperty("position");
					node.style.removeProperty("top");
					node.style.removeProperty("left");
					node.style.removeProperty("right");
					node.style.removeProperty("width");
					node.style.removeProperty("transform");
					node.style.removeProperty("bottom");
					node.style.removeProperty("--fyrco-panel-height");
				}
				if (needsInternalScroll) {
					node.style.setProperty("--fyrco-panel-height", panelMaxHeight + "px");
					node.style.removeProperty("--fyrco-source-max-height");
					node.setAttribute("data-fyrco-panel-scroll", "true");
				} else {
					node.style.removeProperty("--fyrco-panel-height");
					node.style.setProperty("--fyrco-source-max-height", "none");
					node.removeAttribute("data-fyrco-panel-scroll");
				}
				node.style.removeProperty("--fyrco-source-min-height");
				bindAutocompleteLayoutObserver(node);
				observeAutocompletePanelImages(node);
				restoreAutocompleteScrollPositions(savedScroll);
				syncLeftMenuAccordionState(node);
			});
		} finally {
			window._fyrcoLayoutSyncInProgress = false;
		}
	}

	function platformFilterLabel(platformKey) {
		var k = String(platformKey || "").toLowerCase();
		if (k === "all") return algoliaText("all", "Alles");
		if (k === "zendesk") return algoliaText("helpAndAdvice", "Help & advies");
		if (k === "shopify") return algoliaText("webshop", "Webshop");
		if (k === "wordpress") return algoliaText("servicesAndOffers", "Diensten & offertes");
		return String(platformKey || "");
	}

	function typeFilterLabel(typeKey) {
		var v = String(typeKey || "").toLowerCase();
		if (v === "article") return algoliaText("helpAndAdvice", "Help & advies");
		if (v === "product") return algoliaText("products", "Producten");
		if (v === "page") return algoliaText("serviceAndInfo", "Service & info");
		if (v === "collection") return algoliaText("categories", "Categorieën");
		if (v === "post") return algoliaText("servicesAndOffers", "Diensten & offertes");
		return String(typeKey || "");
	}

	function refinementOptionLabel(attributeName, value) {
		var attr = String(attributeName || "");
		if (attr === "platform") {
			return platformFilterLabel(String(value || "").toLowerCase());
		}
		if (attr === "type") {
			return typeFilterLabel(value);
		}
		return String(value || "");
	}

	function configFlagTruthy(config, key) {
		var value = config && config[key];
		return value === true || value === "true" || value === 1 || value === "1";
	}

	function includeShopifyProductsInSearch(config) {
		if (config.includeShopifyProducts === false || config.includeShopifyProducts === "false") {
			return false;
		}
		if (config.includeShopifyProducts === true || config.includeShopifyProducts === "true") {
			return true;
		}
		return isShopifyStorefront();
	}

	function autocompleteSectionTitle(platformKey, recordType, splitShopify) {
		if (platformKey === "zendesk") return algoliaText("helpAndAdvice", "Help & advies");
		if (platformKey === "wordpress") return algoliaText("servicesAndOffers", "Diensten & offertes");
		if (platformKey === "shopify") {
			if (splitShopify && recordType === "product") return algoliaText("products", "Producten");
			if (splitShopify && recordType === "page") return algoliaText("serviceAndInfo", "Service & info");
			if (splitShopify && recordType === "collection") return algoliaText("categories", "Categorieën");
			return algoliaText("webshop", "Webshop");
		}
		return platformKey || "";
	}

	function autocompleteTabLabel(tabKey) {
		var k = String(tabKey || "").toLowerCase();
		if (k === "all") return algoliaText("all", "Alles");
		if (k === "products") return algoliaText("products", "Producten");
		if (k === "advice") return algoliaText("advice", "Advies");
		if (k === "services" || k === "diensten") return algoliaText("services", "Diensten");
		if (k === "offers" || k === "offertes") return algoliaText("offers", "Offertes");
		if (k === "klantverhalen") return algoliaText("customerStories", "Klantverhalen");
		return String(tabKey || "");
	}

	function textContainsAny(value, patterns) {
		var text = String(value || "").toLowerCase();
		if (!text) return false;
		for (var i = 0; i < patterns.length; i += 1) {
			if (text.indexOf(patterns[i]) !== -1) {
				return true;
			}
		}
		return false;
	}

	function isOfferRecord(item) {
		var wpSection = String((item && item.wp_section) || "").toLowerCase();
		if (wpSection === "offerte") return true;
		// A definite non-offer section is authoritative: never let body text like
		// "vraag een offerte aan" on a service/news/story page misclassify it.
		if (wpSection === "diensten" || wpSection === "nieuws" || wpSection === "klantverhalen") {
			return false;
		}
		var url = String((item && item.url) || "").toLowerCase();
		if (url.indexOf("/surveys/") !== -1) return false;
		// URL path is authoritative before falling back to text heuristics.
		if (url.indexOf("/diensten/") !== -1) return false;
		if (url.indexOf("/offerte/") !== -1 || url.indexOf("/offertes/") !== -1) return true;
		var title = String((item && item.title) || "");
		var category = String((item && item.category) || "");
		return textContainsAny(title + " " + url + " " + category, [
			"offerte",
			"offertes",
			"quote",
			"aanvraag"
		]);
	}

	function isServiceRecord(item) {
		var wpSection = String((item && item.wp_section) || "").toLowerCase();
		if (wpSection === "diensten") return true;
		var type = String((item && item.type) || "").toLowerCase();
		var url = String((item && item.url) || "").toLowerCase();
		if (url.indexOf("/surveys/") !== -1) return false;
		if (isNewsRecord(item) || isStoryRecord(item)) return false;
		if (isOfferRecord(item)) return false;
		if (url.indexOf("/diensten/") !== -1) return true;
		if (type === "service" || type === "sector") return true;
		if (type !== "post" && type !== "page") return false;
		return !isOfferRecord(item);
	}

	function isNewsRecord(item) {
		var wpSection = String((item && item.wp_section) || "").toLowerCase();
		if (wpSection === "nieuws") return true;
		var title = String((item && item.title) || "");
		var url = String((item && item.url) || "");
		var category = String((item && item.category) || "");
		return textContainsAny(title + " " + url + " " + category, ["nieuws", "/nieuws/"]);
	}

	function isStoryRecord(item) {
		var wpSection = String((item && item.wp_section) || "").toLowerCase();
		if (wpSection === "klantverhalen") return true;
		var title = String((item && item.title) || "");
		var url = String((item && item.url) || "");
		var category = String((item && item.category) || "");
		return textContainsAny(title + " " + url + " " + category, [
			"klantverhaal",
			"klantverhalen",
			"/klantverhalen/",
			"case"
		]);
	}

	function cardSnippetForDisplay(value) {
		return snippetForDisplay(value, 150);
	}

	function wpSectionTabKey(sectionKey) {
		var key = String(sectionKey || "").toLowerCase();
		if (key === "offerte") return "offertes";
		if (key === "diensten") return "diensten";
		if (key === "klantverhalen") return "klantverhalen";
		return "";
	}

	function formatEuroPrice(value) {
		if (value === null || value === undefined || value === "") return "";
		if (typeof value === "number" && isFinite(value)) {
			return new Intl.NumberFormat("nl-BE", {
				style: "currency",
				currency: "EUR",
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(value).replace(/\s?EUR$/, "").trim();
		}
		var raw = String(value).trim();
		if (!raw) return "";
		var normalized = raw.replace(",", ".").replace(/[^\d.\-]/g, "");
		var parsed = Number(normalized);
		if (!isNaN(parsed) && isFinite(parsed)) {
			return formatEuroPrice(parsed);
		}
		return raw;
	}

	function productPriceLabel(item) {
		var candidate =
			(item && item.price) ||
			(item && item.price_min) ||
			(item && item.priceMin) ||
			(item && item.price_amount) ||
			(item && item.priceAmount) ||
			"";
		return formatEuroPrice(candidate);
	}

	function decodeHtmlEntities(value) {
		var text = String(value || "");
		if (!text) return "";
		var textarea = document.createElement("textarea");
		textarea.innerHTML = text;
		return textarea.value;
	}

	function cleanDisplayText(value) {
		return decodeHtmlEntities(value)
			.replace(/<[^>]*>/g, " ")
			.replace(/\s+/g, " ")
			.trim();
	}

	function extractJavascriptRedirectUrl(text) {
		var raw = String(text || "");
		var patterns = [
			/\bwindow\.location\.(?:replace|assign)\s*\(\s*["']([^"']+)["']\s*\)/i,
			/\bwindow\.location\.href\s*=\s*["']([^"']+)["']/i,
			/\blocation\.(?:replace|assign)\s*\(\s*["']([^"']+)["']\s*\)/i
		];
		for (var i = 0; i < patterns.length; i += 1) {
			var match = raw.match(patterns[i]);
			if (match && match[1]) {
				return String(match[1]).trim();
			}
		}
		return null;
	}

	function servicesBaseUrl(config) {
		var explicit = String((config && config.servicesBaseUrl) || "").trim();
		if (explicit) {
			return explicit.replace(/\/+$/, "");
		}
		return "https://fyrco.be";
	}

	function rewriteHelpCenterOutboundUrl(url, config) {
		if (!url) {
			return url;
		}
		var servicesBase = servicesBaseUrl(config);
		if (!servicesBase) {
			return url;
		}
		try {
			var parsed = new URL(url, window.location.origin);
			var host = normalizeHost(parsed.hostname);
			if (host !== "fyrco.be" && host !== "www.fyrco.be") {
				return parsed.href;
			}
			var servicesHost = normalizeHost(hostFromUrl(servicesBase));
			if (servicesHost === "fyrco.be" || servicesHost === "www.fyrco.be") {
				return parsed.href;
			}
			var path = parsed.pathname.replace(/\/+$/, "") || "";
			if (path === "/offerte/aankoop-plaatsing") {
				return (
					servicesBase +
					"/offerte-aanvragen/offerte-producten-plaatsing/" +
					parsed.search +
					parsed.hash
				);
			}
			if (path.indexOf("/support/") === 0) {
				return servicesBase + path + (path.slice(-1) === "/" ? "" : "/") + parsed.search + parsed.hash;
			}
			if (path === "/offerte") {
				return servicesBase + "/offerte-aanvragen/" + parsed.search + parsed.hash;
			}
			if (path.indexOf("/offerte/") === 0) {
				var slug = path.slice("/offerte/".length);
				if (slug === "aankoop-plaatsing") {
					slug = "offerte-producten-plaatsing";
				}
				return servicesBase + "/offerte-aanvragen/" + slug + "/" + parsed.search + parsed.hash;
			}
			return parsed.href;
		} catch (e) {
			return url;
		}
	}

	function isZendeskHelpCenterPath(pathname) {
		return /^\/hc\//i.test(String(pathname || ""));
	}

	function resolveZendeskOutboundUrl(rawUrl, config) {
		var raw = String(rawUrl || "").trim();
		if (!raw) {
			return null;
		}
		var hasAbsoluteScheme = /^[a-z][a-z\d+\-.]*:/i.test(raw);
		try {
			var parsed = new URL(raw, window.location.origin);
			if (!/^https?:$/i.test(parsed.protocol)) {
				return null;
			}
			if (isZendeskHelpCenterPath(parsed.pathname)) {
				var zendeskBase = platformBaseUrl("zendesk", config) || window.location.origin;
				return (
					joinBaseAndPath(zendeskBase, parsed.pathname + parsed.search + parsed.hash) ||
					parsed.href
				);
			}
			if (hasAbsoluteScheme) {
				return rewriteHelpCenterOutboundUrl(parsed.href, config);
			}
			var outboundBase =
				servicesBaseUrl(config) ||
				platformBaseUrl("wordpress", config) ||
				"https://fyrco.be";
			var joined = joinBaseAndPath(
				outboundBase,
				parsed.pathname + parsed.search + parsed.hash
			);
			return rewriteHelpCenterOutboundUrl(joined || parsed.href, config);
		} catch (e) {
			if (raw.indexOf("/") === 0) {
				var fallbackBase =
					servicesBaseUrl(config) ||
					platformBaseUrl("wordpress", config) ||
					"https://fyrco.be";
				return rewriteHelpCenterOutboundUrl(joinBaseAndPath(fallbackBase, raw), config);
			}
			return null;
		}
	}

	function resolveZendeskItemUrl(item, config) {
		var snippetSource =
			(item && item.snippet) || (item && item.body_safe) || (item && item.body) || "";
		var redirectTarget = extractJavascriptRedirectUrl(snippetSource);
		if (!redirectTarget && item && item.url) {
			var storedUrl = String(item.url).trim();
			if (storedUrl && !isZendeskHelpCenterPath(storedUrl)) {
				try {
					var parsedStored = new URL(storedUrl, window.location.origin);
					if (!isZendeskHelpCenterPath(parsedStored.pathname)) {
						redirectTarget = storedUrl;
					}
				} catch (storedError) {
					if (storedUrl.indexOf("/") === 0) {
						redirectTarget = storedUrl;
					}
				}
			}
		}
		if (redirectTarget) {
			return resolveZendeskOutboundUrl(redirectTarget, config);
		}
		return null;
	}

	function stripSnippetJavascript(text) {
		var cleaned = String(text || "");
		if (!cleaned) {
			return "";
		}
		cleaned = cleaned.replace(/<script[\s\S]*?<\/script>/gi, " ");
		cleaned = cleaned.replace(
			/\bwindow\.location\.(?:replace|assign)\s*\(\s*["'][^"']*["']\s*\)\s*;?/gi,
			" "
		);
		cleaned = cleaned.replace(/\bwindow\.location\.href\s*=\s*["'][^"']*["']\s*;?/gi, " ");
		cleaned = cleaned.replace(
			/\blocation\.(?:replace|assign)\s*\(\s*["'][^"']*["']\s*\)\s*;?/gi,
			" "
		);
		cleaned = cleaned.replace(/\bwindow\.open\s*\(\s*["'][^"']*["'][^)]*\)\s*;?/gi, " ");
		cleaned = cleaned.replace(/\s+/g, " ").trim();
		if (/^(window\.|document\.|javascript:|\(function|function\s*\()/i.test(cleaned)) {
			return "";
		}
		return cleaned;
	}

	function sanitizeSnippetText(value) {
		var text = stripSnippetJavascript(cleanDisplayText(value));
		if (!text) return "";
		text = text.replace(/\d{5,}/g, " ");
		text = text
			.split(/\s+/)
			.filter(function(part) {
				if (!part) return false;
				var digits = (part.match(/\d/g) || []).length;
				return digits < part.length * 0.6;
			})
			.join(" ");
		return text.replace(/\s+/g, " ").trim();
	}

	function snippetForDisplay(value, maxChars) {
		return truncateText(sanitizeSnippetText(value), maxChars);
	}

	function adviceSnippetForDisplay(value) {
		return truncateAtWord(sanitizeSnippetText(value), 220);
	}

	function escapeRegExp(value) {
		return String(value || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	}

	function renderHighlightedQuery(html, text, query) {
		var sourceText = String(text || "");
		var queryText = String(query || "").trim();
		if (!sourceText || !queryText) {
			return sourceText;
		}

		var pattern = new RegExp("(" + escapeRegExp(queryText) + ")", "ig");
		var parts = sourceText.split(pattern);
		var normalizedQuery = queryText.toLowerCase();
		return parts.map(function(part) {
			if (part.toLowerCase() === normalizedQuery) {
				return html`<strong class="aa-QueryMatch">${part}</strong>`;
			}
			return part;
		});
	}

	function platformFilter(baseFilters, platform) {
		return baseFilters + ' AND platform:"' + platform + '"';
	}

	function runSearchRequests(searchClient, requests) {
		if (!searchClient || typeof searchClient.search !== "function") {
			return Promise.reject(new Error("searchClient.search is not available"));
		}
		return Promise.resolve(searchClient.search(requests));
	}

	function attachInsightsMetaToHits(hits, queryID, indexName) {
		return (hits || []).map(function(hit, index) {
			if (!hit || typeof hit !== "object") {
				return hit;
			}
			if (queryID) {
				hit.__queryID = String(queryID);
			}
			hit.__position = index + 1;
			if (indexName) {
				hit.__indexName = String(indexName);
			}
			return hit;
		});
	}

	function normalizeAlgoliaItems(result, indexName) {
		if (Array.isArray(result)) {
			return attachInsightsMetaToHits(result, null, indexName);
		}
		if (result && Array.isArray(result.hits)) {
			return attachInsightsMetaToHits(result.hits, result.queryID, indexName || result.index);
		}
		if (result && Array.isArray(result.items)) {
			return attachInsightsMetaToHits(result.items, result.queryID, indexName || result.index);
		}
		if (result && Array.isArray(result.results)) {
			return result.results.reduce(function(acc, current) {
				var currentIndex = (current && current.index) || indexName;
				var queryID = current && current.queryID;
				if (current && Array.isArray(current.hits)) {
					return acc.concat(attachInsightsMetaToHits(current.hits, queryID, currentIndex));
				}
				if (current && Array.isArray(current.items)) {
					return acc.concat(attachInsightsMetaToHits(current.items, queryID, currentIndex));
				}
				return acc;
			}, []);
		}
		return [];
	}

	function queryPlatformHits(searchClient, indexName, query, filters, platform, limit, recordType, extraFilter) {
		var combined = platformFilter(filters, platform);
		if (recordType) {
			var rt = String(recordType).replace(/"/g, '\\"');
			combined += ' AND type:"' + rt + '"';
		}
		if (extraFilter) {
			combined += " AND " + extraFilter;
		}
		return runSearchRequests(searchClient, [
			{
				indexName: indexName,
				query: query,
				params: {
					hitsPerPage: limit,
					filters: combined,
					clickAnalytics: true
				}
			}
		])
			.then(function(result) {
				return normalizeAlgoliaItems(result, indexName);
			})
			.catch(function(error) {
				console.warn("Algolia platform query failed:", platform, error && error.message);
				return [];
			});
	}

	function queryWordPressSectionHits(searchClient, indexName, query, filters, section, limit) {
		var sectionValue = String(section || "").replace(/"/g, '\\"');
		return queryPlatformHits(
			searchClient,
			indexName,
			query,
			filters,
			"wordpress",
			limit,
			null,
			'wp_section:"' + sectionValue + '"'
		);
	}

	function isShopifyPageMenuCollectionEntry(entry) {
		return String((entry && entry.page_menu_group) || "").toLowerCase() === "collection";
	}

	function splitShopifyPagesForLeftMenu(pages) {
		var categoryPages = [];
		var infoPages = [];
		(pages || []).forEach(function(page) {
			if (isShopifyPageMenuCollectionEntry(page)) {
				categoryPages.push(page);
			} else {
				infoPages.push(page);
			}
		});
		return {
			categoryPages: categoryPages,
			infoPages: infoPages
		};
	}

	function mergeMenuEntries(primaryEntries, secondaryEntries, menuLimit) {
		var merged = (primaryEntries || []).concat(secondaryEntries || []);
		var seen = {};
		return merged
			.filter(function(entry) {
				var key = String((entry && entry.url) || "") + "|" + String((entry && entry.title) || "");
				if (!key || seen[key]) {
					return false;
				}
				seen[key] = true;
				return true;
			})
			.slice(0, menuLimit);
	}

	function queryFallbackHits(searchClient, indexName, query, filters, limit) {
		return runSearchRequests(searchClient, [
			{
				indexName: indexName,
				query: query,
				params: {
					hitsPerPage: limit,
					filters: filters,
					clickAnalytics: true
				}
			}
		])
			.then(function(result) {
				return normalizeAlgoliaItems(result, indexName);
			})
			.catch(function(error) {
				console.warn("Algolia fallback query failed:", error && error.message);
				return [];
			});
	}

	function balanceAutocompleteItems(items, totalLimit, platformCaps) {
		var buckets = {};
		var order = [];
		items.forEach(function(item) {
			var platform = String(item.platform || "other").toLowerCase();
			if (!buckets[platform]) {
				buckets[platform] = [];
				order.push(platform);
			}
			buckets[platform].push(item);
		});

		var picked = [];
		var seen = {};

		Object.keys(platformCaps).forEach(function(platform) {
			var cap = Number(platformCaps[platform] || 0);
			var list = buckets[platform] || [];
			for (var i = 0; i < list.length && cap > 0 && picked.length < totalLimit; i += 1) {
				var item = list[i];
				var key = String(item.url || "") + "|" + String(item.title || "");
				if (seen[key]) continue;
				seen[key] = true;
				picked.push(item);
				cap -= 1;
			}
		});

		for (var j = 0; j < items.length && picked.length < totalLimit; j += 1) {
			var next = items[j];
			var nextKey = String(next.url || "") + "|" + String(next.title || "");
			if (seen[nextKey]) continue;
			seen[nextKey] = true;
			picked.push(next);
		}

		return picked;
	}

	function isMountVisible(mount) {
		if (!mount) return false;
		return !!(mount.offsetParent || (mount.getClientRects && mount.getClientRects().length));
	}

	function getAutocompleteInstances() {
		return window._fyrcoAutocompleteInstances || [];
	}

	function initAlgoliaHeaderAutocomplete(searchClient, config) {
		var mounts = Array.prototype.slice
			.call(document.querySelectorAll("[data-fyrco-algolia-search]"))
			.filter(function(mount) {
				if (!mount) {
					return false;
				}
				if (!mount.querySelector(".aa-Input")) {
					delete mount._fyrcoAutocompleteInitialized;
				}
				return !mount._fyrcoAutocompleteInitialized;
			});
		if (!mounts.length) {
			var legacyMount = document.getElementById("fyrco-algolia-search");
			if (legacyMount && !legacyMount._fyrcoAutocompleteInitialized) {
				mounts = [legacyMount];
			}
		}
		if (!mounts.length) {
			return;
		}

		var autocompleteLib =
			window["@" + "algolia/autocomplete-js"] ||
			(window.autocomplete && { autocomplete: window.autocomplete });
		if (!autocompleteLib) {
			return;
		}

		var locale = String(config.locale || "nl-be").toLowerCase();
		var escapedLocale = locale.replace(/"/g, '\\"');
		var filters = 'is_public:true AND locale:"' + escapedLocale + '"';
		var autocompleteMinQueryLength = Math.max(
			1,
			parseInt(config.autocompleteMinQueryLength, 10) || 3
		);
		var autocompleteDebounceMs = Math.max(
			0,
			parseInt(config.autocompleteDebounceMs, 10) || 450
		);
		var autocompleteTotal = 18;
		var splitShopify = configFlagTruthy(config, "splitShopifySections");
		var includeWordpress = !(
			config.includeWordpress === false || config.includeWordpress === "false"
		);
		var showShopifyProducts = includeShopifyProductsInSearch(config);
		var selectedPlatform = "all";
		var autocompleteInstances = [];
		var adviceLimit = 3;
		var productLimit = 6;
		var wpSectionLimit = 3;
		var servicesLimit = 2;
		var offersLimit = 2;
		var expandedTabLimit = autocompleteTotal;
		var menuLimit = 3;
		var servicesMenuLimit = 8;

		function syncActivePlatformAttribute() {
			getAutocompleteInstances().forEach(function(entry) {
				if (entry && entry.mount) {
					entry.mount.setAttribute("data-fyrco-platform-active", selectedPlatform || "all");
				}
			});
			Array.prototype.slice
				.call(document.querySelectorAll(".aa-Panel, .aa-DetachedContainer"))
				.forEach(function(node) {
					if (node && node.setAttribute) {
						node.setAttribute("data-fyrco-platform-active", selectedPlatform || "all");
					}
				});
		}

		function syncAutocompleteUiState() {
			syncActivePlatformAttribute();
			scheduleAutocompleteLayoutSync();
		}

		function resetAndCloseAutocomplete(options) {
			var opts = options || {};
			var shouldResetPlatform = opts.resetPlatform !== false;
			var shouldClose = opts.close !== false;
			var shouldClearQuery = opts.clearQuery !== false;
			var shouldRefresh = opts.refresh !== false;

			if (shouldResetPlatform) {
				selectedPlatform = "all";
				syncAutocompleteUiState();
			}

			getAutocompleteInstances().forEach(function(entry) {
				var mountNode = entry && entry.mount;
				var instance = entry && entry.instance;
				if (!instance) {
					return;
				}
				if (shouldClose && mountNode && mountNode.setAttribute) {
					mountNode.setAttribute("data-fyrco-ac-panel-open", "false");
				}
				if (shouldClearQuery && typeof instance.setQuery === "function") {
					instance.setQuery("");
				}
				if (shouldRefresh && typeof instance.refresh === "function") {
					instance.refresh();
				}
				if (shouldClose && typeof instance.setIsOpen === "function") {
					instance.setIsOpen(false);
				}
			});
		}

		function forceClosedMountAttributes() {
			getAutocompleteInstances().forEach(function(entry) {
				if (entry && entry.mount && entry.mount.setAttribute) {
					entry.mount.setAttribute("data-fyrco-ac-panel-open", "false");
				}
			});
		}

		function isClickInsideAutocomplete(target) {
			if (!target) return false;
			if (target.closest(".aa-Form")) return true;
			if (target.closest("[data-fyrco-algolia-search]")) return true;
			if (target.closest(".aa-Autocomplete")) return true;
			if (target.closest(".aa-Panel")) return true;
			if (target.closest(".aa-DetachedContainer")) return true;
			return getAutocompleteInstances().some(function(entry) {
				return entry && entry.mount && entry.mount.contains(target);
			});
		}

		if (!window._fyrcoAutocompletePlatformFilterBound) {
			window._fyrcoAutocompletePlatformFilterBound = true;
			document.addEventListener("pointerdown", function(event) {
				var trigger = event.target && event.target.closest("[data-fyrco-platform-filter]");
				if (!trigger) {
					return;
				}
				event.preventDefault();
				event.stopPropagation();
				if (typeof event.stopImmediatePropagation === "function") {
					event.stopImmediatePropagation();
				}
			}, true);
			document.addEventListener("mousedown", function(event) {
				var trigger = event.target && event.target.closest("[data-fyrco-platform-filter]");
				if (!trigger) {
					return;
				}
				// Keep input focus so Autocomplete panel doesn't collapse before filter refresh.
				event.preventDefault();
				event.stopPropagation();
				if (typeof event.stopImmediatePropagation === "function") {
					event.stopImmediatePropagation();
				}
			}, true);
			document.addEventListener("click", function(event) {
				var trigger = event.target && event.target.closest("[data-fyrco-platform-filter]");
				if (!trigger) {
					return;
				}
				event.preventDefault();
				event.stopPropagation();
				if (typeof event.stopImmediatePropagation === "function") {
					event.stopImmediatePropagation();
				}
				var nextPlatform = String(trigger.getAttribute("data-fyrco-platform-filter") || "all").toLowerCase();
				if (window._fyrcoAutocompletePlatformFilterState) {
					window._fyrcoAutocompletePlatformFilterState.setPlatform(nextPlatform);
				}
			}, true);
		}

		// Sidebar group dropdowns (<details>/<summary>): prevent input blur so the
		// Autocomplete panel stays open while the accordion toggles.
		if (!window._fyrcoAutocompleteLeftMenuAccordionBound) {
			window._fyrcoAutocompleteLeftMenuAccordionBound = true;
			function keepAutocompleteFocusForLeftMenuAccordion(event) {
				var trigger = event && event.target && event.target.closest
					? event.target.closest(".aa-LeftMenuAccordionSummary")
					: null;
				if (!trigger) {
					return;
				}
				// preventDefault keeps focus on the search input (same pattern as tabs).
				// Do not stopPropagation — the native <details> toggle still needs click.
				event.preventDefault();
				markAutocompletePanelInteraction(2000);
				getAutocompleteInstances().forEach(function(entry) {
					if (entry && entry.instance && typeof entry.instance.setIsOpen === "function") {
						entry.instance.setIsOpen(true);
					}
					if (entry && entry.mount && entry.mount.setAttribute) {
						entry.mount.setAttribute("data-fyrco-ac-panel-open", "true");
					}
				});
			}
			document.addEventListener("pointerdown", keepAutocompleteFocusForLeftMenuAccordion, true);
			document.addEventListener("mousedown", keepAutocompleteFocusForLeftMenuAccordion, true);
			document.addEventListener(
				"click",
				function(event) {
					var trigger = event && event.target && event.target.closest
						? event.target.closest(".aa-LeftMenuAccordionSummary")
						: null;
					if (!trigger) {
						return;
					}
					var details = trigger.closest(".aa-LeftMenuAccordion");
					if (!details) {
						return;
					}
					// Mobile: toggle manually. preventDefault on mousedown keeps input
					// focus but can suppress the native <details> toggle on some browsers.
					if (isAutocompleteStackedLayout()) {
						event.preventDefault();
						event.stopPropagation();
						if (typeof event.stopImmediatePropagation === "function") {
							event.stopImmediatePropagation();
						}
						var nextOpen = !details.open;
						details.open = nextOpen;
						var key = String(details.getAttribute("data-fyrco-accordion-key") || "").trim();
						if (key) {
							leftMenuAccordionOpenByTitle[key] = nextOpen;
						}
					}
					markAutocompletePanelInteraction(2000);
					getAutocompleteInstances().forEach(function(entry) {
						if (entry && entry.instance && typeof entry.instance.setIsOpen === "function") {
							entry.instance.setIsOpen(true);
						}
						if (entry && entry.mount && entry.mount.setAttribute) {
							entry.mount.setAttribute("data-fyrco-ac-panel-open", "true");
						}
					});
					window.setTimeout(function() {
						Array.prototype.slice
							.call(document.querySelectorAll(".aa-Panel, .aa-DetachedContainer"))
							.forEach(syncLeftMenuAccordionState);
						scheduleAutocompleteLayoutSync({ includeDelayed: true });
					}, 0);
				},
				true
			);
		}

		if (!window._fyrcoAutocompleteDismissBound) {
			window._fyrcoAutocompleteDismissBound = true;
			document.addEventListener(
				"pointerdown",
				function(event) {
					var target = event && event.target;
					if (
						target &&
						target.closest &&
						(target.closest(".aa-Panel") || target.closest(".aa-DetachedContainer"))
					) {
						// iOS: touching the panel blurs the input; keep panel open while scrolling.
						markAutocompletePanelInteraction(1500);
					}
				},
				true
			);
			document.addEventListener(
				"touchstart",
				function(event) {
					var target = event && event.target;
					if (
						target &&
						target.closest &&
						(target.closest(".aa-Panel") || target.closest(".aa-DetachedContainer"))
					) {
						markAutocompletePanelInteraction(1500);
					}
				},
				{ capture: true, passive: true }
			);
			document.addEventListener("pointerdown", function(event) {
				var state = window._fyrcoAutocompleteDismissState;
				if (!state || !event) {
					return;
				}
				var target = event.target;
				if (target && target.closest && target.closest("[data-fyrco-platform-filter]")) {
					return;
				}
				if (state.isInside && state.isInside(target)) {
					return;
				}
				if (shouldSuppressAutocompleteDismiss()) {
					return;
				}
				if (state.resetAndClose) {
					state.resetAndClose();
				}
				forceClosedMountAttributes();
			});
			document.addEventListener("focusin", function(event) {
				var state = window._fyrcoAutocompleteDismissState;
				if (!state || !event) {
					return;
				}
				var target = event.target;
				if (target && target.closest && target.closest("[data-fyrco-platform-filter]")) {
					return;
				}
				if (state.isInside && state.isInside(target)) {
					return;
				}
				if (shouldSuppressAutocompleteDismiss()) {
					getAutocompleteInstances().forEach(function(entry) {
						if (entry && entry.instance && typeof entry.instance.setIsOpen === "function") {
							entry.instance.setIsOpen(true);
						}
					});
					return;
				}
				if (state.resetAndClose) {
					state.resetAndClose();
				}
				getAutocompleteInstances().forEach(function(entry) {
					if (entry && entry.mount && entry.mount.setAttribute) {
						entry.mount.setAttribute("data-fyrco-ac-panel-open", "false");
					}
				});
			}, true);
			document.addEventListener("keydown", function(event) {
				if (!event || event.key !== "Escape") {
					return;
				}
				var state = window._fyrcoAutocompleteDismissState;
				if (!state) {
					return;
				}
				var target = event.target;
				var activeElement = document.activeElement;
				var targetInside = state.isInside && state.isInside(target);
				var activeInside = state.isInside && state.isInside(activeElement);
				if (!targetInside && !activeInside) {
					return;
				}
				if (state.resetAndClose) {
					state.resetAndClose();
				}
			});
		}

		autocompleteInstances = mounts.map(function(mount) {
			mount._fyrcoAutocompleteInitialized = true;
			mount.setAttribute("data-fyrco-ac-panel-open", "false");
			mount.setAttribute("data-fyrco-platform-active", selectedPlatform);
			// Capture translated placeholder from Liquid fallback BEFORE wiping the mount
			// (Autocomplete overlays a new input; NL JS-fallback was covering the FR text underneath).
			var existingInput = mount.querySelector("input[type='search'], input[placeholder], input");
			var existingPlaceholder = existingInput
				? String(existingInput.getAttribute("placeholder") || existingInput.getAttribute("aria-label") || "").trim()
				: "";
			mount.innerHTML = "";
			var instance = autocompleteLib.autocomplete({
				container: mount,
				placeholder: algoliaText(
					"searchPlaceholder",
					existingPlaceholder || "Zoek hier vb. Brandblusser"
				),
				openOnFocus: true,
				stallThreshold: autocompleteDebounceMs + 300,
				detachedMediaQuery: "(max-width: 0px)",
				onStateChange: function(params) {
					var prev = (params && params.prevState) || {};
					var next = (params && params.state) || {};
					mount.setAttribute(
						"data-fyrco-ac-panel-open",
						next.isOpen ? "true" : "false"
					);
					if (!next.isOpen) {
						leftMenuAccordionOpenByTitle = {};
					}
					var layoutDecision = shouldSyncAutocompleteLayout(prev, next);
					if (layoutDecision.sync) {
						scheduleAutocompleteLayoutSync({ includeDelayed: layoutDecision.delayed });
					} else if (didOnlyActiveAutocompleteItemChange(prev, next)) {
						Array.prototype.slice
							.call(document.querySelectorAll(".aa-Panel, .aa-DetachedContainer"))
							.forEach(preserveAutocompleteScrollOnNextFrame);
					}
					var previousQuery = String(prev.query || "").trim();
					var nextQuery = String(next.query || "").trim();
					if (previousQuery && !nextQuery) {
						resetAndCloseAutocomplete({
							clearQuery: false,
							close: true,
							resetPlatform: true,
							refresh: true
						});
					}
				},
				onSubmit: function(params) {
					var state = params.state || {};
					var collections = state.collections || [];
					var firstItem = null;
					for (var c = 0; c < collections.length; c += 1) {
						var items = collections[c] && collections[c].items;
						if (items && items.length) {
							firstItem = items[0];
							break;
						}
					}

					// Mobile: keyboard Search/Enter should keep results open for scrolling,
					// not jump to the first hit or close the panel.
					if (isMobileAutocompleteViewport() && firstItem) {
						markAutocompletePanelInteraction(2000);
						if (typeof instance.setIsOpen === "function") {
							instance.setIsOpen(true);
						}
						mount.setAttribute("data-fyrco-ac-panel-open", "true");
						var inputEl = mount.querySelector(".aa-Input");
						if (inputEl && typeof inputEl.blur === "function") {
							inputEl.blur();
						}
						scheduleAutocompleteLayoutSync({ includeDelayed: true });
						return;
					}

					navigateToItem(firstItem, config);
				},
			navigator: {
				navigate: function(params) {
					navigateToItem(params.item, config);
				}
			},
			getSources: debouncePromise(function(params) {
				// Temperen: pas zoeken vanaf N tekens + debounce (minder Algolia-requests).
				var searchQuery = String(params.query || "").trim();
				if (searchQuery.length < autocompleteMinQueryLength) {
					return [];
				}

				function buildSearchResultsUrlForQuery() {
					return buildSearchResultsUrl(config, searchQuery);
				}

				function queryWordpressHitsFiltered(limit, predicate) {
					if (!includeWordpress) {
						return Promise.resolve([]);
					}
					var queryLimit = Math.max(limit * 20, 120);
					function dedupeWordpressItems(items) {
						var seen = {};
						return (items || []).filter(function(entry) {
							var key = String((entry && entry.url) || "") + "|" + String((entry && entry.title) || "");
							if (!key || seen[key]) return false;
							seen[key] = true;
							return true;
						});
					}
					return queryPlatformHits(
						searchClient,
						config.indexName,
						searchQuery,
						filters,
						"wordpress",
						queryLimit,
						null
					).then(function(items) {
						return dedupeWordpressItems(items).filter(predicate).slice(0, limit);
					});
				}

				function renderFyrcoResultCard(html, item, queryText) {
					var imageUrl = item.image || "";
					var titleText = cleanDisplayText(item.title);
					var snippetShort = cardSnippetForDisplay(item.snippet);
					var cardUrl = resolveItemUrl(item, config) || "#";
					return withExternalAnchor(
						html,
						cardUrl,
						"aa-FyrcoCardLink",
						html`
							<div class="aa-ItemWrapper aa-ResultRow aa-FyrcoCardRow">
								${imageUrl
									? html`
										<div class="aa-ItemIcon aa-ItemIcon--picture">
											<img src="${imageUrl}" alt="" loading="lazy" />
										</div>
									`
									: ""}
								<div class="aa-ItemContent">
									<div class="aa-ItemContentBody">
										<div class="aa-ItemContentTitle">${renderHighlightedQuery(html, titleText, queryText)}</div>
										${snippetShort
											? html`<div class="aa-ItemContentDescription">${renderHighlightedQuery(html, snippetShort, queryText)}</div>`
											: ""}
									</div>
								</div>
							</div>
						`,
						item
					);
				}

				function renderFyrcoAdviceItem(html, item, queryText) {
					var titleText = cleanDisplayText(item.title);
					var snippetShort = adviceSnippetForDisplay(item.snippet);
					var adviceUrl = resolveItemUrl(item, config) || "#";
					return withExternalAnchor(
						html,
						adviceUrl,
						"aa-BbhAdviceRow",
						html`
							<div class="aa-ItemWrapper aa-ResultRow aa-ResultRow--advice">
								<div class="aa-ItemContent">
									<div class="aa-ItemContentBody">
										<div class="aa-ItemContentTitle">${renderHighlightedQuery(html, titleText, queryText)}</div>
										${snippetShort
											? html`<div class="aa-ItemContentDescription">${renderHighlightedQuery(html, snippetShort, queryText)}</div>`
											: ""}
									</div>
								</div>
							</div>
						`,
						item
					);
				}

				function createTabsHeader(html) {
					var active = selectedPlatform;
					if (isFyrcoWordPressSite()) {
						return html`
							<div class="aa-SourceHeaderFilters aa-SourceHeaderFilters--bbh aa-SourceHeaderFilters--fyrco-wp">
								<button type="button" class="aa-PlatformFilterButton" data-fyrco-platform-filter="all" aria-pressed="${active === "all"}">${autocompleteTabLabel("all")}</button>
								<button type="button" class="aa-PlatformFilterButton" data-fyrco-platform-filter="services" aria-pressed="${active === "services"}">${autocompleteTabLabel("services")}</button>
								<button type="button" class="aa-PlatformFilterButton" data-fyrco-platform-filter="offers" aria-pressed="${active === "offers"}">${autocompleteTabLabel("offers")}</button>
								<button type="button" class="aa-PlatformFilterButton" data-fyrco-platform-filter="advice" aria-pressed="${active === "advice"}">${autocompleteTabLabel("advice")}</button>
							</div>
						`;
					}
					return html`
						<div class="aa-SourceHeaderFilters aa-SourceHeaderFilters--bbh">
							<button type="button" class="aa-PlatformFilterButton" data-fyrco-platform-filter="all" aria-pressed="${active === "all"}">${autocompleteTabLabel("all")}</button>
							${showShopifyProducts
								? html`<button type="button" class="aa-PlatformFilterButton" data-fyrco-platform-filter="products" aria-pressed="${active === "products"}">${autocompleteTabLabel("products")}</button>`
								: ""}
							<button type="button" class="aa-PlatformFilterButton" data-fyrco-platform-filter="advice" aria-pressed="${active === "advice"}">${autocompleteTabLabel("advice")}</button>
						</div>
					`;
				}

				function createTabsSource() {
					return {
						sourceId: "ubersearch_tabs",
						getItems: function() {
							return [{}];
						},
						templates: {
							item: function(templateParams) {
								var html = templateParams.html;
								return html`${createTabsHeader(html)}`;
							}
						}
					};
				}

				function createLeftMenuSource() {
					function serviceOfferDisplayTitle(entry) {
						var baseTitle = cleanDisplayText(entry && entry.title);
						var url = String((entry && entry.url) || "").toLowerCase();
						if (!baseTitle) return "";
						if (url.indexOf("/offerte/") !== -1 && !/^offerte\b/i.test(baseTitle)) {
							return algoliaText("offerPrefix", "Offerte") + " " + baseTitle;
						}
						return baseTitle;
					}

					return {
						sourceId: "ubersearch_left_menu",
						getItems: function() {
							function isWpServiceOrOfferEntry(item) {
								var url = String((item && item.url) || "").toLowerCase();
								if (!url) return false;
								return (
									url.indexOf("/diensten/") !== -1 ||
									url.indexOf("/offerte/") !== -1 ||
									url.indexOf("/offertes/") !== -1
								);
							}

							function dedupeByUrlAndTitle(items) {
								var seen = {};
								return (items || []).filter(function(entry) {
									var key = String((entry && entry.url) || "") + "|" + String((entry && entry.title) || "");
									if (!key || seen[key]) return false;
									seen[key] = true;
									return true;
								});
							}

							function slugifyQuery(value) {
								return String(value || "")
									.toLowerCase()
									.normalize("NFD")
									.replace(/[\u0300-\u036f]/g, "")
									.replace(/[^a-z0-9]+/g, "-")
									.replace(/^-+|-+$/g, "");
							}

							function prioritizeServiceOfferEntries(entries, queryText) {
								var querySlug = slugifyQuery(queryText);
								return (entries || [])
									.map(function(entry, index) {
										var url = String((entry && entry.url) || "").toLowerCase();
										var score = 0;

										if (/\/offerte\/[^/]+\/?$/i.test(url)) score += 30;
										if (/\/diensten\/[^/]+\/?$/i.test(url)) score += 24;
										if (url.indexOf("/calculator/") !== -1) score -= 12;

										if (querySlug) {
											if (url.indexOf("/offerte/" + querySlug + "/") !== -1) score += 60;
											if (url.indexOf("/diensten/" + querySlug + "/") !== -1) score += 52;
										}

										return { entry: entry, index: index, score: score };
									})
									.sort(function(a, b) {
										if (b.score !== a.score) return b.score - a.score;
										return a.index - b.index;
									})
									.map(function(row) {
										return row.entry;
									});
							}

							return Promise.all([
								queryPlatformHits(searchClient, config.indexName, searchQuery, filters, "shopify", menuLimit + 2, "collection"),
								isFyrcoWordPressSite() && includeWordpress
									? queryWordpressHitsFiltered(menuLimit * 3, function() {
											return true;
										})
									: Promise.resolve([]),
								!isFyrcoWordPressSite()
									? queryPlatformHits(searchClient, config.indexName, searchQuery, filters, "shopify", menuLimit * 2, "page")
									: Promise.resolve([]),
								includeWordpress && !isFyrcoWordPressSite()
									? queryPlatformHits(searchClient, config.indexName, searchQuery, filters, "wordpress", servicesMenuLimit * 8, null)
									: Promise.resolve([])
							]).then(function(results) {
								if (isFyrcoWordPressSite()) {
									var wpItems = results[1] || [];
									return [
										{
											collections: (results[0] || []).slice(0, menuLimit),
											news: wpItems.filter(isNewsRecord).slice(0, menuLimit),
											stories: wpItems.filter(isStoryRecord).slice(0, menuLimit)
										}
									];
								}
								var wpServices = prioritizeServiceOfferEntries(
									dedupeByUrlAndTitle(results[3]).filter(isWpServiceOrOfferEntry),
									searchQuery
								).slice(0, servicesMenuLimit);
								var splitPages = splitShopifyPagesForLeftMenu(results[2] || []);
								return [
									{
										collections: mergeMenuEntries(results[0] || [], splitPages.categoryPages, menuLimit),
										pages: splitPages.infoPages.slice(0, menuLimit),
										services: wpServices
									}
								];
							});
						},
						templates: {
							item: function(templateParams) {
								var html = templateParams.html;
								var item = templateParams.item || {};
								function renderMenuGroup(title, entries) {
									if (!entries || !entries.length) return "";
									var stacked = isAutocompleteStackedLayout();
									var shouldOpen = !stacked || !!leftMenuAccordionOpenByTitle[title];
									return html`
										<details
											class="aa-BbhMenuGroup aa-LeftMenuAccordion"
											data-fyrco-accordion-key=${title}
											open=${shouldOpen ? true : undefined}
										>
											<summary class="aa-LeftMenuAccordionSummary">
												<span>${title}</span>
											</summary>
											<div class="aa-LeftMenuAccordionBody">
												<ul>
													${entries.map(function(entry) {
														var entryUrl = resolveItemUrl(entry, config) || "#";
														return html`
															<li>
																${withExternalAnchor(html, entryUrl, "", cleanDisplayText(entry.title), entry)}
															</li>
														`;
													})}
												</ul>
											</div>
										</details>
									`;
								}
								if (isFyrcoWordPressSite()) {
									var hasFyrcoMenu =
										(item.news && item.news.length) ||
										(item.stories && item.stories.length) ||
										(item.collections && item.collections.length);
									if (!hasFyrcoMenu) {
										return html`<aside class="aa-BbhLeftMenu aa-FyrcoLeftMenu aa-FyrcoLeftMenu--empty"></aside>`;
									}
									return html`
										<aside class="aa-BbhLeftMenu aa-FyrcoLeftMenu">
											${renderMenuGroup(algoliaText("news", "Nieuws"), item.news)}
											${renderMenuGroup(algoliaText("customerStories", "Klantverhalen"), item.stories)}
											${renderMenuGroup(algoliaText("webshop", "Webshop"), item.collections)}
										</aside>
									`;
								}
								var hasBbhMenu =
									(item.collections && item.collections.length) ||
									(item.pages && item.pages.length) ||
									(item.services && item.services.length);
								if (!hasBbhMenu) {
									return html`<aside class="aa-BbhLeftMenu aa-BbhLeftMenu--empty"></aside>`;
								}
								return html`
									<aside class="aa-BbhLeftMenu">
										${renderMenuGroup(algoliaText("categories", "Categorieën"), item.collections)}
										${renderMenuGroup(algoliaText("information", "Informatie"), item.pages)}
										${renderMenuGroup(
											algoliaText("servicesAndOffers", "Diensten & offertes"),
											(item.services || []).map(function(entry) {
												var copy = {};
												Object.keys(entry || {}).forEach(function(key) {
													copy[key] = entry[key];
												});
												copy.title = serviceOfferDisplayTitle(entry);
												return copy;
											})
										)}
									</aside>
								`;
							}
						}
					};
				}

				function createFyrcoServicesSource(limit, showMoreAction) {
					return {
						sourceId: "ubersearch_services",
						onSelect: function(sourceParams) {
							navigateToItem(sourceParams.item, config);
						},
						getItemInputValue: function(sourceParams) {
							return (sourceParams.item && sourceParams.item.title) || "";
						},
						getItemUrl: function(sourceParams) {
							return resolveItemUrl(sourceParams.item, config);
						},
						getItems: function() {
							return queryWordpressHitsFiltered(limit, isServiceRecord);
						},
						templates: {
							header: function(templateParams) {
														if (!templateParams.items || !templateParams.items.length) return "";
														return templateParams.html`<div class="aa-PlatformSectionTitle aa-PlatformSectionTitle--compact">${algoliaText("services", "Diensten")}</div>`;
							},
							noResults: function(templateParams) {
								if (selectedPlatform === "advice" || selectedPlatform === "offers") return "";
								var queryText =
									(templateParams.state && String(templateParams.state.query || "").trim()) || "";
								return renderAutocompleteEmptyFallback(templateParams.html, queryText, config, {
															label: algoliaText("noServices", "Geen diensten gevonden"),
									message: queryText
																? algoliaTextForQuery("noServices", 'Geen diensten voor "{{ query }}".', queryText)
																: algoliaText("noServices", "Geen diensten gevonden.")
								});
							},
							item: function(templateParams) {
								var html = templateParams.html;
								var item = templateParams.item;
								var queryText = (templateParams.state && String(templateParams.state.query || "").trim()) || "";
								return html`<div class="aa-FyrcoCardListItem">${renderFyrcoResultCard(html, item, queryText)}</div>`;
							},
							footer: function(templateParams) {
								var html = templateParams.html;
								var items = templateParams.items || [];
								if (!items.length || !showMoreAction) return "";
														return html`<div class="aa-SourceFooter aa-SourceFooter--right"><button type="button" class="aa-ViewAllLink aa-ViewAllAction" data-fyrco-platform-filter="services">${algoliaText("showMore", "Toon meer")} <span aria-hidden="true">›</span></button></div>`;
							}
						}
					};
				}

				function createFyrcoOffersSource(limit, showMoreAction) {
					return {
						sourceId: "ubersearch_offers",
						onSelect: function(sourceParams) {
							navigateToItem(sourceParams.item, config);
						},
						getItemInputValue: function(sourceParams) {
							return (sourceParams.item && sourceParams.item.title) || "";
						},
						getItemUrl: function(sourceParams) {
							return resolveItemUrl(sourceParams.item, config);
						},
						getItems: function() {
							return queryWordpressHitsFiltered(limit, isOfferRecord);
						},
						templates: {
							header: function(templateParams) {
								if (!templateParams.items || !templateParams.items.length) return "";
														return templateParams.html`<div class="aa-PlatformSectionTitle aa-PlatformSectionTitle--compact">${algoliaText("offers", "Offertes")}</div>`;
							},
							noResults: function(templateParams) {
								if (selectedPlatform === "advice" || selectedPlatform === "services") return "";
								var queryText =
									(templateParams.state && String(templateParams.state.query || "").trim()) || "";
								return renderAutocompleteEmptyFallback(templateParams.html, queryText, config, {
															label: algoliaText("noOffers", "Geen offertes gevonden"),
									message: queryText
																? algoliaTextForQuery("noOffers", 'Geen offertes voor "{{ query }}".', queryText)
																: algoliaText("noOffers", "Geen offertes gevonden.")
								});
							},
							item: function(templateParams) {
								var html = templateParams.html;
								var item = templateParams.item;
								var queryText = (templateParams.state && String(templateParams.state.query || "").trim()) || "";
								return html`<div class="aa-FyrcoCardListItem">${renderFyrcoResultCard(html, item, queryText)}</div>`;
							},
							footer: function(templateParams) {
								var html = templateParams.html;
								var items = templateParams.items || [];
								if (!items.length || !showMoreAction) return "";
														return html`<div class="aa-SourceFooter aa-SourceFooter--right"><button type="button" class="aa-ViewAllLink aa-ViewAllAction" data-fyrco-platform-filter="offers">${algoliaText("showMore", "Toon meer")} <span aria-hidden="true">›</span></button></div>`;
							}
						}
					};
				}

				function createAdviceSource(limit, showMoreAction) {
					return {
						sourceId: "ubersearch_advice",
						onSelect: function(sourceParams) {
							navigateToItem(sourceParams.item, config);
						},
						getItemInputValue: function(sourceParams) {
							return (sourceParams.item && sourceParams.item.title) || "";
						},
						getItemUrl: function(sourceParams) {
							return resolveItemUrl(sourceParams.item, config);
						},
						getItems: function() {
							return queryPlatformHits(
								searchClient,
								config.indexName,
								searchQuery,
								filters,
								"zendesk",
								limit,
								"article"
							);
						},
						templates: {
							header: function(templateParams) {
								if (!templateParams.items || !templateParams.items.length) return "";
								var html = templateParams.html;
								return html`
															<div class="aa-PlatformSectionTitle aa-PlatformSectionTitle--compact">${algoliaText("advice", "Advies")}</div>
								`;
							},
							noResults: function(templateParams) {
								if (
									selectedPlatform === "products" ||
									(isFyrcoWordPressSite() &&
										(selectedPlatform === "services" || selectedPlatform === "offers"))
								) {
									return "";
								}
								var queryText =
									(templateParams.state && String(templateParams.state.query || "").trim()) || "";
								return renderAutocompleteEmptyFallback(templateParams.html, queryText, config, {
															label: algoliaText("noAdvice", "Geen advies gevonden"),
									message: queryText
																? algoliaTextForQuery("noAdviceArticles", 'Geen adviesartikelen voor "{{ query }}".', queryText)
																: algoliaText("noAdviceArticles", "Geen adviesartikelen gevonden.")
								});
							},
							item: function(templateParams) {
								var item = templateParams.item;
								var html = templateParams.html;
								var queryText = (templateParams.state && String(templateParams.state.query || "").trim()) || "";
								var titleText = cleanDisplayText(item.title);
								var snippetShort = adviceSnippetForDisplay(item.snippet);
								return html`
									<div class="aa-ItemWrapper aa-ResultRow aa-ResultRow--advice">
										<div class="aa-ItemContent">
											<div class="aa-ItemContentBody">
												<div class="aa-ItemContentTitle">${renderHighlightedQuery(html, titleText, queryText)}</div>
												${snippetShort ? html`<div class="aa-ItemContentDescription">${renderHighlightedQuery(html, snippetShort, queryText)}</div>` : ""}
											</div>
										</div>
									</div>
								`;
							},
							footer: function(templateParams) {
								var html = templateParams.html;
								var items = templateParams.items || [];
								if (!items.length || !showMoreAction) return "";
														return html`<div class="aa-SourceFooter aa-SourceFooter--right"><button type="button" class="aa-ViewAllLink aa-ViewAllAction" data-fyrco-platform-filter="advice">${algoliaText("showMore", "Toon meer")} <span aria-hidden="true">›</span></button></div>`;
							}
						}
					};
				}

				function createWordPressSectionSource(sectionKey, sectionLabel, limit, showMoreAction) {
					var tabFilter = wpSectionTabKey(sectionKey);
					return {
						sourceId: "ubersearch_wp_" + sectionKey,
						onSelect: function(sourceParams) {
							navigateToItem(sourceParams.item, config);
						},
						getItemInputValue: function(sourceParams) {
							return (sourceParams.item && sourceParams.item.title) || "";
						},
						getItemUrl: function(sourceParams) {
							return resolveItemUrl(sourceParams.item, config);
						},
						getItems: function() {
							return queryWordPressSectionHits(
								searchClient,
								config.indexName,
								searchQuery,
								filters,
								sectionKey,
								limit
							);
						},
						templates: {
							header: function(templateParams) {
								if (!templateParams.items || !templateParams.items.length) return "";
								var html = templateParams.html;
								return html`
									<div class="aa-PlatformSectionTitle aa-PlatformSectionTitle--compact">${sectionLabel}</div>
								`;
							},
							noResults: function(templateParams) {
								var queryText =
									(templateParams.state && String(templateParams.state.query || "").trim()) || "";
								return renderAutocompleteEmptyFallback(templateParams.html, queryText, config, {
															label: algoliaText("noResultsTitle", "Geen resultaten gevonden"),
									message: queryText
																? algoliaTextForQuery("noResultsForQuery", 'Geen resultaten voor "{{ query }}".', queryText)
																: algoliaText("noResultsIn", "Geen resultaten gevonden.")
								});
							},
							item: function(templateParams) {
								var item = templateParams.item;
								var html = templateParams.html;
								var queryText = (templateParams.state && String(templateParams.state.query || "").trim()) || "";
								var titleText = cleanDisplayText(item.title);
								var snippetShort = adviceSnippetForDisplay(item.snippet);
								return html`
									<div class="aa-ItemWrapper aa-ResultRow aa-ResultRow--advice">
										<div class="aa-ItemContent">
											<div class="aa-ItemContentBody">
												<div class="aa-ItemContentTitle">${renderHighlightedQuery(html, titleText, queryText)}</div>
												${snippetShort ? html`<div class="aa-ItemContentDescription">${renderHighlightedQuery(html, snippetShort, queryText)}</div>` : ""}
											</div>
										</div>
									</div>
								`;
							},
							footer: function(templateParams) {
								var html = templateParams.html;
								var items = templateParams.items || [];
								if (!items.length || !showMoreAction || !tabFilter) return "";
								return html`<div class="aa-SourceFooter aa-SourceFooter--right"><button type="button" class="aa-ViewAllLink aa-ViewAllAction" data-fyrco-platform-filter="${tabFilter}">${algoliaText("showMore", "Toon meer")} <span aria-hidden="true">›</span></button></div>`;
							}
						}
					};
				}

				function createProductsSource(sectionLabel, limit, showMoreAction) {
					return {
						sourceId: "ubersearch_products",
						onSelect: function(sourceParams) {
							navigateToItem(sourceParams.item, config);
						},
						getItemInputValue: function(sourceParams) {
							return (sourceParams.item && sourceParams.item.title) || "";
						},
						getItemUrl: function(sourceParams) {
							return resolveItemUrl(sourceParams.item, config);
						},
						getItems: function() {
							return queryPlatformHits(
								searchClient,
								config.indexName,
								searchQuery,
								filters,
								"shopify",
								limit,
								"product"
							);
						},
						templates: {
							header: function(templateParams) {
								if (!templateParams.items || !templateParams.items.length) return "";
								var html = templateParams.html;
								return html`
																<div class="aa-PlatformSectionTitle aa-PlatformSectionTitle--compact">${sectionLabel || algoliaText("ourRange", "Ons assortiment")}</div>
								`;
							},
							noResults: function(templateParams) {
								if (selectedPlatform === "advice") return "";
								var queryText =
									(templateParams.state && String(templateParams.state.query || "").trim()) || "";
								return renderAutocompleteEmptyFallback(templateParams.html, queryText, config, {
															label: algoliaText("noProducts", "Geen producten gevonden"),
									message: queryText
																? algoliaTextForQuery("noProducts", 'Geen producten voor "{{ query }}".', queryText)
																: algoliaText("noProducts", "Geen producten gevonden.")
								});
							},
							item: function(templateParams) {
								var item = templateParams.item;
								var html = templateParams.html;
								var imageUrl = item.image || "";
								var price = productPriceLabel(item);
								var productUrl = resolveItemUrl(item, config) || "#";
								return html`
									<div class="aa-BbhProductCard">
										${withExternalAnchor(
											html,
											productUrl,
											"aa-BbhProductCardLink",
											html`
												<div class="aa-BbhProductThumb">
													${imageUrl ? html`<img src="${imageUrl}" alt="" loading="lazy" />` : ""}
												</div>
												<div class="aa-BbhProductTitle">${cleanDisplayText(item.title)}</div>
												${price ? html`<div class="aa-BbhProductPrice">${price}</div>` : ""}
											`,
											item
										)}
									</div>
								`;
							},
							footer: function(templateParams) {
								var html = templateParams.html;
								var items = templateParams.items || [];
								if (!items.length || !showMoreAction) return "";
														return html`<div class="aa-SourceFooter aa-SourceFooter--right"><button type="button" class="aa-ViewAllLink aa-ViewAllAction" data-fyrco-platform-filter="products">${algoliaText("showMore", "Toon meer")} <span aria-hidden="true">›</span></button></div>`;
							}
						}
					};
				}

				function createAllResultsSource() {
					return {
						sourceId: "ubersearch_all",
						getItems: function() {
							if (isFyrcoWordPressSite()) {
								return Promise.all([
									queryWordpressHitsFiltered(servicesLimit, isServiceRecord),
									queryWordpressHitsFiltered(offersLimit, isOfferRecord),
									queryPlatformHits(
										searchClient,
										config.indexName,
										searchQuery,
										filters,
										"zendesk",
										adviceLimit,
										"article"
									)
								]).then(function(results) {
									return [
										{
											services: results[0] || [],
											offers: results[1] || [],
											advice: results[2] || []
										}
									];
								});
							}
							return Promise.all([
								queryPlatformHits(
									searchClient,
									config.indexName,
									searchQuery,
									filters,
									"zendesk",
									adviceLimit,
									"article"
								),
								showShopifyProducts
									? queryPlatformHits(
											searchClient,
											config.indexName,
											searchQuery,
											filters,
											"shopify",
											productLimit,
											"product"
										)
									: Promise.resolve([])
							]).then(function(results) {
								return [
									{
										advice: results[0] || [],
										products: results[1] || []
									}
								];
							});
						},
						templates: {
							item: function(templateParams) {
								var html = templateParams.html;
								var data = templateParams.item || {};
								var queryText = (templateParams.state && String(templateParams.state.query || "").trim()) || "";
								function renderAdviceListBody(items) {
									return html`
										<div class="aa-BbhAdviceList">
											${(items || []).map(function(item) {
												var titleText = cleanDisplayText(item.title);
												var snippetShort = adviceSnippetForDisplay(item.snippet);
												var adviceUrl = resolveItemUrl(item, config) || "#";
												return html`
													<div class="aa-BbhAdviceListItem">
														${withExternalAnchor(
															html,
															adviceUrl,
															"aa-BbhAdviceRow",
															html`
																<div class="aa-ItemWrapper aa-ResultRow aa-ResultRow--advice">
																	<div class="aa-ItemContent">
																		<div class="aa-ItemContentBody">
																			<div class="aa-ItemContentTitle">${renderHighlightedQuery(html, titleText, queryText)}</div>
																			${snippetShort ? html`<div class="aa-ItemContentDescription">${renderHighlightedQuery(html, snippetShort, queryText)}</div>` : ""}
																		</div>
																	</div>
																</div>
															`,
															item
														)}
													</div>
												`;
											})}
										</div>
									`;
								}
								function renderMixedSection(sectionOptions) {
									var items = sectionOptions.items || [];
									var blockClass = items.length
										? "aa-FyrcoSectionBlock--has-results"
										: "aa-FyrcoSectionBlock--empty";
									return html`
										<section class="aa-FyrcoSectionBlock ${blockClass}">
											<div class="aa-PlatformSectionTitle aa-PlatformSectionTitle--compact">${sectionOptions.title}</div>
											${items.length
												? sectionOptions.body
												: html`<div class="aa-NoResults">${sectionOptions.emptyLabel}</div>`}
											${items.length && sectionOptions.filter
																? html`<div class="aa-SourceFooter aa-SourceFooter--right"><button type="button" class="aa-ViewAllLink aa-ViewAllAction" data-fyrco-platform-filter="${sectionOptions.filter}">${algoliaText("showMore", "Toon meer")} <span aria-hidden="true">›</span></button></div>`
												: ""}
										</section>
									`;
								}
								if (isFyrcoWordPressSite()) {
									var serviceItems = data.services || [];
									var offerItems = data.offers || [];
									var adviceItems = data.advice || [];
									if (!serviceItems.length && !offerItems.length && !adviceItems.length) {
										return html`<div class="aa-BbhAllResults aa-FyrcoAllResults">${renderAutocompleteEmptyFallback(html, queryText, config)}</div>`;
									}
									return html`
										<div class="aa-BbhAllResults aa-FyrcoAllResults aa-FyrcoAllResults--wp">
											${renderMixedSection({
																										title: algoliaText("services", "Diensten"),
												items: serviceItems,
																																															emptyLabel: algoliaText("noServices", "Geen diensten gevonden."),
												filter: "services",
												body: html`<div class="aa-FyrcoCardList">${serviceItems.map(function(item) {
													return html`<div class="aa-FyrcoCardListItem">${renderFyrcoResultCard(html, item, queryText)}</div>`;
												})}</div>`
											})}
											${renderMixedSection({
																																										title: algoliaText("offers", "Offertes"),
												items: offerItems,
																																															emptyLabel: algoliaText("noOffers", "Geen offertes gevonden."),
												filter: "offers",
												body: html`<div class="aa-FyrcoCardList">${offerItems.map(function(item) {
													return html`<div class="aa-FyrcoCardListItem">${renderFyrcoResultCard(html, item, queryText)}</div>`;
												})}</div>`
											})}
											${renderMixedSection({
																																																title: algoliaText("advice", "Advies"),
												items: adviceItems,
																																															emptyLabel: algoliaText("noAdvice", "Geen advies gevonden."),
												filter: "advice",
												body: html`<div class="aa-BbhAdviceList">${adviceItems.map(function(item) {
													return html`<div class="aa-BbhAdviceListItem">${renderFyrcoAdviceItem(html, item, queryText)}</div>`;
												})}</div>`
											})}
										</div>
									`;
								}
								var adviceItems = data.advice || [];
								var productItems = data.products || [];
								if (!adviceItems.length && (!showShopifyProducts || !productItems.length)) {
									return html`<div class="aa-BbhAllResults aa-FyrcoAllResults">${renderAutocompleteEmptyFallback(html, queryText, config)}</div>`;
								}
								var adviceSection = renderMixedSection({
																														title: algoliaText("advice", "Advies"),
									items: adviceItems,
																																											emptyLabel: algoliaText("noAdvice", "Geen advies gevonden."),
									filter: "advice",
									body: renderAdviceListBody(adviceItems)
								});
								if (!showShopifyProducts) {
									return html`<div class="aa-BbhAllResults aa-FyrcoAllResults">${adviceSection}</div>`;
								}
								var productsSection = renderMixedSection({
																																										title: algoliaText("ourRange", "Ons assortiment"),
									items: productItems,
																																											emptyLabel: algoliaText("noProducts", "Geen producten gevonden."),
									filter: "products",
									body: html`
										<div class="aa-BbhProductGrid">
											${productItems.map(function(item) {
												var imageUrl = item.image || "";
												var price = productPriceLabel(item);
												var productUrl = resolveItemUrl(item, config) || "#";
												return html`
													<div class="aa-BbhProductCard">
														${withExternalAnchor(
															html,
															productUrl,
															"aa-BbhProductCardLink",
															html`
																<div class="aa-BbhProductThumb">
																	${imageUrl ? html`<img src="${imageUrl}" alt="" loading="lazy" />` : ""}
																</div>
																<div class="aa-BbhProductTitle">${cleanDisplayText(item.title)}</div>
																${price ? html`<div class="aa-BbhProductPrice">${price}</div>` : ""}
															`,
															item
														)}
													</div>
												`;
											})}
										</div>
									`
								});
								return html`
									<div class="aa-BbhAllResults aa-FyrcoAllResults">
										${isShopifyStorefront() ? productsSection : adviceSection}
										${isShopifyStorefront() ? adviceSection : productsSection}
									</div>
								`;
							}
						}
					};
				}

				function createGlobalEmptySource() {
					return {
						sourceId: "ubersearch_global_empty",
						getItems: function() {
							return [{ empty: true }];
						},
						templates: {
							item: function(templateParams) {
								var html = templateParams.html;
								var queryText =
									(templateParams.state && String(templateParams.state.query || "").trim()) || "";
								return html`<div class="aa-BbhAllResults aa-FyrcoAllResults--solo-empty">${renderAutocompleteEmptyFallback(html, queryText, config)}</div>`;
							}
						}
					};
				}

				function hasAnySearchHits() {
					if (isFyrcoWordPressSite()) {
						return Promise.all([
							includeWordpress ? queryWordpressHitsFiltered(1, isServiceRecord) : Promise.resolve([]),
							includeWordpress ? queryWordpressHitsFiltered(1, isOfferRecord) : Promise.resolve([]),
							queryPlatformHits(searchClient, config.indexName, searchQuery, filters, "zendesk", 1, "article")
						]).then(function(results) {
							return (
								((results[0] && results[0].length) || 0) +
									((results[1] && results[1].length) || 0) +
									((results[2] && results[2].length) || 0) >
								0
							);
						});
					}
					var requests = [
						queryPlatformHits(searchClient, config.indexName, searchQuery, filters, "zendesk", 1, "article")
					];
					if (showShopifyProducts) {
						requests.push(
							queryPlatformHits(searchClient, config.indexName, searchQuery, filters, "shopify", 1, "product")
						);
					}
					return Promise.all(requests).then(function(results) {
						return results.some(function(group) {
							return (group && group.length) || 0;
						});
					});
				}

				function buildResultSources() {
					var rows = [createLeftMenuSource(), createTabsSource()];
					if (isFyrcoWordPressSite()) {
						if (selectedPlatform === "services") {
							rows.push(createFyrcoServicesSource(expandedTabLimit, false));
							return rows;
						}
						if (selectedPlatform === "offers") {
							rows.push(createFyrcoOffersSource(expandedTabLimit, false));
							return rows;
						}
						if (selectedPlatform === "advice") {
							rows.push(createAdviceSource(expandedTabLimit, false));
							return rows;
						}
						rows.push(createAllResultsSource());
						return rows;
					}
					if (selectedPlatform === "products" && showShopifyProducts) {
						rows.push(createProductsSource(algoliaText("ourRange", "Ons assortiment"), expandedTabLimit, false));
						return rows;
					}
					if (selectedPlatform === "advice") {
						rows.push(createAdviceSource(expandedTabLimit, false));
						return rows;
					}
					if (selectedPlatform === "diensten") {
						rows.push(createWordPressSectionSource("diensten", algoliaText("services", "Diensten"), expandedTabLimit, false));
						return rows;
					}
					if (selectedPlatform === "offertes") {
						rows.push(createWordPressSectionSource("offerte", algoliaText("offers", "Offertes"), expandedTabLimit, false));
						return rows;
					}
					if (selectedPlatform === "klantverhalen") {
						rows.push(createWordPressSectionSource("klantverhalen", algoliaText("customerStories", "Klantverhalen"), expandedTabLimit, false));
						return rows;
					}
					rows.push(createAllResultsSource());
					return rows;
				}

				return hasAnySearchHits().then(function(hasAny) {
					if (!hasAny) {
						return [createLeftMenuSource(), createGlobalEmptySource()];
					}
					return buildResultSources();
				});
			}, autocompleteDebounceMs)
			});
			mount.addEventListener("focusout", function() {
				window.setTimeout(function() {
					var active = document.activeElement;
					if (isClickInsideAutocomplete(active)) {
						return;
					}
					if (shouldSuppressAutocompleteDismiss()) {
						if (typeof instance.setIsOpen === "function") {
							instance.setIsOpen(true);
						}
						if (mount.setAttribute) {
							mount.setAttribute("data-fyrco-ac-panel-open", "true");
						}
						scheduleAutocompleteLayoutSync({ includeDelayed: true });
						return;
					}
					if (mount.setAttribute) {
						mount.setAttribute("data-fyrco-ac-panel-open", "false");
					}
					if (typeof instance.setIsOpen === "function") {
						instance.setIsOpen(false);
					}
					if (typeof instance.refresh === "function") {
						instance.refresh();
					}
					var anyOpen = getAutocompleteInstances().some(function(entry) {
						return (
							entry &&
							entry.mount &&
							entry.mount.getAttribute("data-fyrco-ac-panel-open") === "true"
						);
					});
					if (!anyOpen) {
						selectedPlatform = "all";
						syncAutocompleteUiState();
					}
				}, 50);
			});
			return { mount: mount, instance: instance };
		});

		if (window._fyrcoAutocompleteInstances) {
			autocompleteInstances = window._fyrcoAutocompleteInstances.concat(autocompleteInstances);
		}
		window._fyrcoAutocompleteInstances = autocompleteInstances;

		window._fyrcoAutocompletePlatformFilterState = {
			setPlatform: function(nextPlatform) {
				selectedPlatform = nextPlatform || "all";
				syncAutocompleteUiState();
				var targets = getAutocompleteInstances().filter(function(entry) {
					return isMountVisible(entry.mount);
				});
				if (!targets.length) {
					targets = getAutocompleteInstances();
				}
				targets.forEach(function(entry) {
					var instance = entry.instance;
					if (instance && typeof instance.refresh === "function") {
						instance.refresh();
					}
					if (instance && typeof instance.setIsOpen === "function") {
						instance.setIsOpen(true);
					}
				});
				syncAutocompleteUiState();
				scheduleAutocompleteLayoutSync();
			}
		};

		if (!window._fyrcoAutocompleteLayoutSyncBound) {
			window._fyrcoAutocompleteLayoutSyncBound = true;
			window.addEventListener("resize", function() {
				syncAutocompleteLayoutMetrics();
			});
			if (window.visualViewport) {
				window.visualViewport.addEventListener("resize", function() {
					syncAutocompleteLayoutMetrics();
				});
				window.visualViewport.addEventListener("scroll", function() {
					syncAutocompleteLayoutMetrics();
				});
			}
		}

		syncAutocompleteUiState();

		window._fyrcoAutocompleteDismissState = {
			isInside: isClickInsideAutocomplete,
			resetAndClose: function() {
				resetAndCloseAutocomplete({
					clearQuery: false,
					close: true,
					resetPlatform: true,
					refresh: true
				});
			}
		};
	}

	function initAlgoliaSearchResultsPage(searchClient, config) {
		var root = document.getElementById("fyrco-algolia-results");
		if (!root) {
			return;
		}

		var zendeskResults = document.querySelector("[data-fyrco-zendesk-results]");
		var useZendeskFallback = config.resultsPageFallback !== "algolia" && Boolean(zendeskResults);
		var algoliaAvailable = false;

		function showZendeskResults() {
			if (!useZendeskFallback) {
				return;
			}
			root.hidden = true;
			if (window.jQuery) {
				window.jQuery("[data-fyrco-zendesk-results]").removeAttr("hidden");
			} else if (zendeskResults) {
				zendeskResults.removeAttribute("hidden");
			}
		}

		function showAlgoliaResults() {
			root.hidden = false;
			if (window.jQuery) {
				window.jQuery("[data-fyrco-zendesk-results]").attr("hidden", "hidden");
			} else if (zendeskResults) {
				zendeskResults.setAttribute("hidden", "hidden");
			}
		}

		// Help Center: toon Zendesk-fallback tot Algolia hits heeft. Shopify: direct Algolia.
		if (useZendeskFallback) {
			showZendeskResults();
		} else {
			showAlgoliaResults();
		}

		var locale = String(config.locale || "nl-be").toLowerCase();
		var queryParam = getSearchQueryFromUrl(config);
		var escapedLocale = locale.replace(/"/g, '\\"');
		var escapedQuery = queryParam.replace(/"/g, '\\"');

		var search = window.instantsearch({
			indexName: config.indexName,
			searchClient: searchClient,
			insights: insightsEnabled(config),
			initialUiState: (function() {
				var state = {};
				state[config.indexName] = {
					query: escapedQuery
				};
				return state;
			})(),
			// Zendesk's existing query URL shape conflicts with InstantSearch router state mapping.
			// Keep query bootstrap via initialUiState and disable router to avoid runtime crashes.
			routing: false
		});

		search.addWidgets([
			window.instantsearch.widgets.configure({
				hitsPerPage: Number(config.hitsPerPage || 12),
				filters: 'is_public:true AND locale:"' + escapedLocale + '"',
				distinct: true,
				clickAnalytics: insightsEnabled(config)
			}),
			window.instantsearch.widgets.searchBox({
				container: "#fyrco-algolia-searchbox",
				placeholder: algoliaText("searchPlaceholder", "Zoek hier vb. Brandblusser"),
				showSubmit: true,
				showReset: true,
				showLoadingIndicator: false,
				queryHook: function(query, searchFn) {
					var q = String(query || "").trim();
					var minLen = Math.max(
						1,
						parseInt(config.autocompleteMinQueryLength, 10) || 3
					);
					if (!q.length || q.length >= minLen) {
						searchFn(query);
					}
				}
			}),
			window.instantsearch.widgets.stats({
				container: "#fyrco-algolia-stats"
			}),
			window.instantsearch.widgets.clearRefinements({
				container: "#fyrco-algolia-clear-refinements",
				templates: {
					resetLabel: algoliaText("clearFilters", "Wis filters")
				}
			}),
			window.instantsearch.widgets.currentRefinements({
				container: "#fyrco-algolia-current-refinements",
				transformItems: function(items) {
					return items.map(function(item) {
						var copy = Object.assign({}, item);
						if (copy.refinements) {
							copy.refinements = copy.refinements.map(function(r) {
								var next = Object.assign({}, r);
								if (next.value !== undefined) {
									next.label = refinementOptionLabel(item.attribute, next.value);
								}
								return next;
							});
						}
						return copy;
					});
				}
			}),
			window.instantsearch.widgets.refinementList({
				container: "#fyrco-algolia-filter-platform",
				attribute: "platform",
				transformItems: function(items) {
					return items.map(function(item) {
						return Object.assign({}, item, {
							label: refinementOptionLabel("platform", item.value)
						});
					});
				}
			}),
			window.instantsearch.widgets.refinementList({
				container: "#fyrco-algolia-filter-type",
				attribute: "type",
				transformItems: function(items) {
					return items.map(function(item) {
						return Object.assign({}, item, {
							label: refinementOptionLabel("type", item.value)
						});
					});
				}
			}),
			window.instantsearch.widgets.refinementList({
				container: "#fyrco-algolia-filter-category",
				attribute: "category"
			}),
			window.instantsearch.widgets.hits({
				container: "#fyrco-algolia-hits",
				transformItems: function(items) {
					return items.map(function(item) {
						item.source_label = sourceDomainLabel(item, config);
						var resolvedUrl = resolveItemUrl(item, config);
						if (resolvedUrl) {
							item.url = resolvedUrl;
						}
						return item;
					});
				},
				templates: {
					empty: function() {
						return buildResultsPageEmptyHtml(queryParam, config);
					},
					item:
						"<article class=\"fyrco-algolia-hit\">" +
							"<a class=\"fyrco-algolia-hit-link\" href=\"{{url}}\">" +
								"<div class=\"fyrco-algolia-hit-body\">" +
									"<span class=\"fyrco-algolia-hit-badge\">{{source_label}}</span>" +
									"<h3 class=\"fyrco-algolia-hit-title\">{{#helpers.highlight}}{\"attribute\":\"title\"}{{/helpers.highlight}}</h3>" +
								"</div>" +
								"{{#image}}" +
									"<div class=\"fyrco-algolia-hit-thumb\"><img src=\"{{image}}\" alt=\"\" loading=\"lazy\" /></div>" +
								"{{/image}}" +
							"</a>" +
						"</article>"
				}
			}),
			window.instantsearch.widgets.pagination({
				container: "#fyrco-algolia-pagination"
			})
		]);

		search.on("render", function() {
			var results = search && search.helper ? search.helper.lastResults : null;
			if (results) {
				algoliaAvailable = true;
				showAlgoliaResults();
				return;
			}
			if (useZendeskFallback) {
				showZendeskResults();
			} else {
				showAlgoliaResults();
			}
		});

		search.on("error", function(error) {
			if (error) {
				console.error("Algolia search error on results page:", error);
			}
			if (useZendeskFallback) {
				showZendeskResults();
			} else {
				showAlgoliaResults();
			}
		});

		search.start();

		if (useZendeskFallback) {
			// If Algolia never rendered valid hits, keep Zendesk fallback visible.
			window.setTimeout(function() {
				if (!algoliaAvailable) {
					showZendeskResults();
				}
			}, 1500);
		}
	}

	function initAlgoliaSearchIntegration() {
		var config = window.FYRCO_ALGOLIA_CONFIG || {};
		if (!config.appId || !config.searchApiKey || !config.indexName) {
			return;
		}

		var retries = 0;
		var maxRetries = 20;
		var retryDelayMs = 250;

		function libsReadyAutocomplete() {
			return Boolean(getAlgoliaFactory() && getAutocompleteLib());
		}

		function boot() {
			if (!libsReadyAutocomplete()) {
				retries += 1;
				if (retries <= maxRetries) {
					window.setTimeout(boot, retryDelayMs);
				}
				return;
			}

			try {
				var algoliaFactory = getAlgoliaFactory();
				var searchClient = algoliaFactory(config.appId, config.searchApiKey);
				ensureInsightsInitialized(config);
				bindInsightsAnchorClicks(config);
				initAlgoliaHeaderAutocomplete(searchClient, config);
				if (
					config.enableAlgoliaResultsPage === true &&
					document.getElementById("fyrco-algolia-results") &&
					window.instantsearch
				) {
					initAlgoliaSearchResultsPage(searchClient, config);
				}
			} catch (error) {
				console.error("Algolia init failed:", error);
			}
		}

		boot();
	}

	window.fyrcoInitAlgoliaSearchIntegration = initAlgoliaSearchIntegration;
})();
